var items = {
  "block.minecraft.acacia_button": "Акациевая кнопка",
  "block.minecraft.acacia_door": "Акациевая дверь",
  "block.minecraft.acacia_fence": "Акациевый забор",
  "block.minecraft.acacia_fence_gate": "Акациевая калитка",
  "block.minecraft.acacia_hanging_sign": "Акациевая подвесная табличка",
  "block.minecraft.acacia_leaves": "Листья акации",
  "block.minecraft.acacia_log": "Акациевое бревно",
  "block.minecraft.acacia_planks": "Акациевые доски",
  "block.minecraft.acacia_pressure_plate": "Акациевая нажимная плита",
  "block.minecraft.acacia_sapling": "Саженец акации",
  "block.minecraft.acacia_shelf": "Акациевая полка",
  "block.minecraft.acacia_sign": "Акациевая табличка",
  "block.minecraft.acacia_slab": "Акациевая плита",
  "block.minecraft.acacia_stairs": "Акациевые ступеньки",
  "block.minecraft.acacia_trapdoor": "Акациевый люк",
  "block.minecraft.acacia_wall_hanging_sign": "Акациевая настенная подвесная табличка",
  "block.minecraft.acacia_wall_sign": "Акациевая настенная табличка",
  "block.minecraft.acacia_wood": "Акация",
  "block.minecraft.activator_rail": "Активирующие рельсы",
  "block.minecraft.air": "Воздух",
  "block.minecraft.allium": "Лук-батун",
  "block.minecraft.amethyst_block": "Аметистовый блок",
  "block.minecraft.amethyst_cluster": "Аметистовая друза",
  "block.minecraft.ancient_debris": "Древние обломки",
  "block.minecraft.andesite": "Андезит",
  "block.minecraft.andesite_slab": "Андезитовая плита",
  "block.minecraft.andesite_stairs": "Андезитовые ступеньки",
  "block.minecraft.andesite_wall": "Андезитовая ограда",
  "block.minecraft.anvil": "Наковальня",
  "block.minecraft.attached_melon_stem": "Прикреплённый стебель арбуза",
  "block.minecraft.attached_pumpkin_stem": "Прикреплённый стебель тыквы",
  "block.minecraft.azalea": "Азалия",
  "block.minecraft.azalea_leaves": "Листья азалии",
  "block.minecraft.azure_bluet": "Хаустония серая",
  "block.minecraft.bamboo": "Бамбук",
  "block.minecraft.bamboo_block": "Блок бамбука",
  "block.minecraft.bamboo_button": "Бамбуковая кнопка",
  "block.minecraft.bamboo_door": "Бамбуковая дверь",
  "block.minecraft.bamboo_fence": "Бамбуковый забор",
  "block.minecraft.bamboo_fence_gate": "Бамбуковая калитка",
  "block.minecraft.bamboo_hanging_sign": "Бамбуковая подвесная табличка",
  "block.minecraft.bamboo_mosaic": "Бамбуковая мозаика",
  "block.minecraft.bamboo_mosaic_slab": "Плита из бамбуковой мозаики",
  "block.minecraft.bamboo_mosaic_stairs": "Ступеньки из бамбуковой мозаики",
  "block.minecraft.bamboo_planks": "Бамбуковые доски",
  "block.minecraft.bamboo_pressure_plate": "Бамбуковая нажимная плита",
  "block.minecraft.bamboo_sapling": "Побег бамбука",
  "block.minecraft.bamboo_shelf": "Бамбуковая полка",
  "block.minecraft.bamboo_sign": "Бамбуковая табличка",
  "block.minecraft.bamboo_slab": "Бамбуковая плита",
  "block.minecraft.bamboo_stairs": "Бамбуковые ступеньки",
  "block.minecraft.bamboo_trapdoor": "Бамбуковый люк",
  "block.minecraft.bamboo_wall_hanging_sign": "Бамбуковая настенная подвесная табличка",
  "block.minecraft.bamboo_wall_sign": "Бамбуковая настенная табличка",
  "block.minecraft.banner.base.black": "Чёрное поле",
  "block.minecraft.banner.base.blue": "Синее поле",
  "block.minecraft.banner.base.brown": "Коричневое поле",
  "block.minecraft.banner.base.cyan": "Бирюзовое поле",
  "block.minecraft.banner.base.gray": "Серое поле",
  "block.minecraft.banner.base.green": "Зелёное поле",
  "block.minecraft.banner.base.light_blue": "Голубое поле",
  "block.minecraft.banner.base.light_gray": "Светло-серое поле",
  "block.minecraft.banner.base.lime": "Лаймовое поле",
  "block.minecraft.banner.base.magenta": "Пурпурное поле",
  "block.minecraft.banner.base.orange": "Оранжевое поле",
  "block.minecraft.banner.base.pink": "Розовое поле",
  "block.minecraft.banner.base.purple": "Фиолетовое поле",
  "block.minecraft.banner.base.red": "Красное поле",
  "block.minecraft.banner.base.white": "Белое поле",
  "block.minecraft.banner.base.yellow": "Жёлтое поле",
  "block.minecraft.banner.border.black": "Чёрная кайма",
  "block.minecraft.banner.border.blue": "Синяя кайма",
  "block.minecraft.banner.border.brown": "Коричневая кайма",
  "block.minecraft.banner.border.cyan": "Бирюзовая кайма",
  "block.minecraft.banner.border.gray": "Серая кайма",
  "block.minecraft.banner.border.green": "Зелёная кайма",
  "block.minecraft.banner.border.light_blue": "Голубая кайма",
  "block.minecraft.banner.border.light_gray": "Светло-серая кайма",
  "block.minecraft.banner.border.lime": "Лаймовая кайма",
  "block.minecraft.banner.border.magenta": "Пурпурная кайма",
  "block.minecraft.banner.border.orange": "Оранжевая кайма",
  "block.minecraft.banner.border.pink": "Розовая кайма",
  "block.minecraft.banner.border.purple": "Фиолетовая кайма",
  "block.minecraft.banner.border.red": "Красная кайма",
  "block.minecraft.banner.border.white": "Белая кайма",
  "block.minecraft.banner.border.yellow": "Жёлтая кайма",
  "block.minecraft.banner.bricks.black": "Чёрная муровка",
  "block.minecraft.banner.bricks.blue": "Синяя муровка",
  "block.minecraft.banner.bricks.brown": "Коричневая муровка",
  "block.minecraft.banner.bricks.cyan": "Бирюзовая муровка",
  "block.minecraft.banner.bricks.gray": "Серая муровка",
  "block.minecraft.banner.bricks.green": "Зелёная муровка",
  "block.minecraft.banner.bricks.light_blue": "Голубая муровка",
  "block.minecraft.banner.bricks.light_gray": "Светло-серая муровка",
  "block.minecraft.banner.bricks.lime": "Лаймовая муровка",
  "block.minecraft.banner.bricks.magenta": "Пурпурная муровка",
  "block.minecraft.banner.bricks.orange": "Оранжевая муровка",
  "block.minecraft.banner.bricks.pink": "Розовая муровка",
  "block.minecraft.banner.bricks.purple": "Фиолетовая муровка",
  "block.minecraft.banner.bricks.red": "Красная муровка",
  "block.minecraft.banner.bricks.white": "Белая муровка",
  "block.minecraft.banner.bricks.yellow": "Жёлтая муровка",
  "block.minecraft.banner.circle.black": "Чёрный круг",
  "block.minecraft.banner.circle.blue": "Синий круг",
  "block.minecraft.banner.circle.brown": "Коричневый круг",
  "block.minecraft.banner.circle.cyan": "Бирюзовый круг",
  "block.minecraft.banner.circle.gray": "Серый круг",
  "block.minecraft.banner.circle.green": "Зелёный круг",
  "block.minecraft.banner.circle.light_blue": "Голубой круг",
  "block.minecraft.banner.circle.light_gray": "Светло-серый круг",
  "block.minecraft.banner.circle.lime": "Лаймовый круг",
  "block.minecraft.banner.circle.magenta": "Пурпурный круг",
  "block.minecraft.banner.circle.orange": "Оранжевый круг",
  "block.minecraft.banner.circle.pink": "Розовый круг",
  "block.minecraft.banner.circle.purple": "Фиолетовый круг",
  "block.minecraft.banner.circle.red": "Красный круг",
  "block.minecraft.banner.circle.white": "Белый круг",
  "block.minecraft.banner.circle.yellow": "Жёлтый круг",
  "block.minecraft.banner.creeper.black": "Чёрный крипер",
  "block.minecraft.banner.creeper.blue": "Синий крипер",
  "block.minecraft.banner.creeper.brown": "Коричневый крипер",
  "block.minecraft.banner.creeper.cyan": "Бирюзовый крипер",
  "block.minecraft.banner.creeper.gray": "Серый крипер",
  "block.minecraft.banner.creeper.green": "Зелёный крипер",
  "block.minecraft.banner.creeper.light_blue": "Голубой крипер",
  "block.minecraft.banner.creeper.light_gray": "Светло-серый крипер",
  "block.minecraft.banner.creeper.lime": "Лаймовый крипер",
  "block.minecraft.banner.creeper.magenta": "Пурпурный крипер",
  "block.minecraft.banner.creeper.orange": "Оранжевый крипер",
  "block.minecraft.banner.creeper.pink": "Розовый крипер",
  "block.minecraft.banner.creeper.purple": "Фиолетовый крипер",
  "block.minecraft.banner.creeper.red": "Красный крипер",
  "block.minecraft.banner.creeper.white": "Белый крипер",
  "block.minecraft.banner.creeper.yellow": "Жёлтый крипер",
  "block.minecraft.banner.cross.black": "Чёрный Андреевский крест",
  "block.minecraft.banner.cross.blue": "Синий Андреевский крест",
  "block.minecraft.banner.cross.brown": "Коричневый Андреевский крест",
  "block.minecraft.banner.cross.cyan": "Бирюзовый Андреевский крест",
  "block.minecraft.banner.cross.gray": "Серый Андреевский крест",
  "block.minecraft.banner.cross.green": "Зелёный Андреевский крест",
  "block.minecraft.banner.cross.light_blue": "Голубой Андреевский крест",
  "block.minecraft.banner.cross.light_gray": "Светло-серый Андреевский крест",
  "block.minecraft.banner.cross.lime": "Лаймовый Андреевский крест",
  "block.minecraft.banner.cross.magenta": "Пурпурный Андреевский крест",
  "block.minecraft.banner.cross.orange": "Оранжевый Андреевский крест",
  "block.minecraft.banner.cross.pink": "Розовый Андреевский крест",
  "block.minecraft.banner.cross.purple": "Фиолетовый Андреевский крест",
  "block.minecraft.banner.cross.red": "Красный Андреевский крест",
  "block.minecraft.banner.cross.white": "Белый Андреевский крест",
  "block.minecraft.banner.cross.yellow": "Жёлтый Андреевский крест",
  "block.minecraft.banner.curly_border.black": "Чёрная зубчатая кайма",
  "block.minecraft.banner.curly_border.blue": "Синяя зубчатая кайма",
  "block.minecraft.banner.curly_border.brown": "Коричневая зубчатая кайма",
  "block.minecraft.banner.curly_border.cyan": "Бирюзовая зубчатая кайма",
  "block.minecraft.banner.curly_border.gray": "Серая зубчатая кайма",
  "block.minecraft.banner.curly_border.green": "Зелёная зубчатая кайма",
  "block.minecraft.banner.curly_border.light_blue": "Голубая зубчатая кайма",
  "block.minecraft.banner.curly_border.light_gray": "Светло-серая зубчатая кайма",
  "block.minecraft.banner.curly_border.lime": "Лаймовая зубчатая кайма",
  "block.minecraft.banner.curly_border.magenta": "Пурпурная зубчатая кайма",
  "block.minecraft.banner.curly_border.orange": "Оранжевая зубчатая кайма",
  "block.minecraft.banner.curly_border.pink": "Розовая зубчатая кайма",
  "block.minecraft.banner.curly_border.purple": "Фиолетовая зубчатая кайма",
  "block.minecraft.banner.curly_border.red": "Красная зубчатая кайма",
  "block.minecraft.banner.curly_border.white": "Белая зубчатая кайма",
  "block.minecraft.banner.curly_border.yellow": "Жёлтая зубчатая кайма",
  "block.minecraft.banner.diagonal_left.black": "Чёрное скошение слева",
  "block.minecraft.banner.diagonal_left.blue": "Синее скошение слева",
  "block.minecraft.banner.diagonal_left.brown": "Коричневое скошение слева",
  "block.minecraft.banner.diagonal_left.cyan": "Бирюзовое скошение слева",
  "block.minecraft.banner.diagonal_left.gray": "Серое скошение слева",
  "block.minecraft.banner.diagonal_left.green": "Зелёное скошение слева",
  "block.minecraft.banner.diagonal_left.light_blue": "Голубое скошение слева",
  "block.minecraft.banner.diagonal_left.light_gray": "Светло-серое скошение слева",
  "block.minecraft.banner.diagonal_left.lime": "Лаймовое скошение слева",
  "block.minecraft.banner.diagonal_left.magenta": "Пурпурное скошение слева",
  "block.minecraft.banner.diagonal_left.orange": "Оранжевое скошение слева",
  "block.minecraft.banner.diagonal_left.pink": "Розовое скошение слева",
  "block.minecraft.banner.diagonal_left.purple": "Фиолетовое скошение слева",
  "block.minecraft.banner.diagonal_left.red": "Красное скошение слева",
  "block.minecraft.banner.diagonal_left.white": "Белое скошение слева",
  "block.minecraft.banner.diagonal_left.yellow": "Жёлтое скошение слева",
  "block.minecraft.banner.diagonal_right.black": "Чёрное скошение",
  "block.minecraft.banner.diagonal_right.blue": "Синее скошение",
  "block.minecraft.banner.diagonal_right.brown": "Коричневое скошение",
  "block.minecraft.banner.diagonal_right.cyan": "Бирюзовое скошение",
  "block.minecraft.banner.diagonal_right.gray": "Серое скошение",
  "block.minecraft.banner.diagonal_right.green": "Зелёное скошение",
  "block.minecraft.banner.diagonal_right.light_blue": "Голубое скошение",
  "block.minecraft.banner.diagonal_right.light_gray": "Светло-серое скошение",
  "block.minecraft.banner.diagonal_right.lime": "Лаймовое скошение",
  "block.minecraft.banner.diagonal_right.magenta": "Пурпурное скошение",
  "block.minecraft.banner.diagonal_right.orange": "Оранжевое скошение",
  "block.minecraft.banner.diagonal_right.pink": "Розовое скошение",
  "block.minecraft.banner.diagonal_right.purple": "Фиолетовое скошение",
  "block.minecraft.banner.diagonal_right.red": "Красное скошение",
  "block.minecraft.banner.diagonal_right.white": "Белое скошение",
  "block.minecraft.banner.diagonal_right.yellow": "Жёлтое скошение",
  "block.minecraft.banner.diagonal_up_left.black": "Чёрное опрокинутое скошение",
  "block.minecraft.banner.diagonal_up_left.blue": "Синее опрокинутое скошение",
  "block.minecraft.banner.diagonal_up_left.brown": "Коричневое опрокинутое скошение",
  "block.minecraft.banner.diagonal_up_left.cyan": "Бирюзовое опрокинутое скошение",
  "block.minecraft.banner.diagonal_up_left.gray": "Серое опрокинутое скошение",
  "block.minecraft.banner.diagonal_up_left.green": "Зелёное опрокинутое скошение",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Голубое опрокинутое скошение",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Светло-серое опрокинутое скошение",
  "block.minecraft.banner.diagonal_up_left.lime": "Лаймовое опрокинутое скошение",
  "block.minecraft.banner.diagonal_up_left.magenta": "Пурпурное опрокинутое скошение",
  "block.minecraft.banner.diagonal_up_left.orange": "Оранжевое опрокинутое скошение",
  "block.minecraft.banner.diagonal_up_left.pink": "Розовое опрокинутое скошение",
  "block.minecraft.banner.diagonal_up_left.purple": "Фиолетовое опрокинутое скошение",
  "block.minecraft.banner.diagonal_up_left.red": "Красное опрокинутое скошение",
  "block.minecraft.banner.diagonal_up_left.white": "Белое опрокинутое скошение",
  "block.minecraft.banner.diagonal_up_left.yellow": "Жёлтое опрокинутое скошение",
  "block.minecraft.banner.diagonal_up_right.black": "Чёрное опрокинутое скошение слева",
  "block.minecraft.banner.diagonal_up_right.blue": "Синее опрокинутое скошение слева",
  "block.minecraft.banner.diagonal_up_right.brown": "Коричневое опрокинутое скошение слева",
  "block.minecraft.banner.diagonal_up_right.cyan": "Бирюзовое опрокинутое скошение слева",
  "block.minecraft.banner.diagonal_up_right.gray": "Серое опрокинутое скошение слева",
  "block.minecraft.banner.diagonal_up_right.green": "Зелёное опрокинутое скошение слева",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Голубое опрокинутое скошение слева",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Светло-серое опрокинутое скошение слева",
  "block.minecraft.banner.diagonal_up_right.lime": "Лаймовое опрокинутое скошение слева",
  "block.minecraft.banner.diagonal_up_right.magenta": "Пурпурное опрокинутое скошение слева",
  "block.minecraft.banner.diagonal_up_right.orange": "Оранжевое опрокинутое скошение слева",
  "block.minecraft.banner.diagonal_up_right.pink": "Розовое опрокинутое скошение слева",
  "block.minecraft.banner.diagonal_up_right.purple": "Фиолетовое опрокинутое скошение слева",
  "block.minecraft.banner.diagonal_up_right.red": "Красное опрокинутое скошение слева",
  "block.minecraft.banner.diagonal_up_right.white": "Белое опрокинутое скошение слева",
  "block.minecraft.banner.diagonal_up_right.yellow": "Жёлтое опрокинутое скошение слева",
  "block.minecraft.banner.flow.black": "Чёрный поток",
  "block.minecraft.banner.flow.blue": "Синий поток",
  "block.minecraft.banner.flow.brown": "Коричневый поток",
  "block.minecraft.banner.flow.cyan": "Бирюзовый поток",
  "block.minecraft.banner.flow.gray": "Серый поток",
  "block.minecraft.banner.flow.green": "Зелёный поток",
  "block.minecraft.banner.flow.light_blue": "Голубой поток",
  "block.minecraft.banner.flow.light_gray": "Светло-серый поток",
  "block.minecraft.banner.flow.lime": "Лаймовый поток",
  "block.minecraft.banner.flow.magenta": "Пурпурный поток",
  "block.minecraft.banner.flow.orange": "Оранжевый поток",
  "block.minecraft.banner.flow.pink": "Розовый поток",
  "block.minecraft.banner.flow.purple": "Фиолетовый поток",
  "block.minecraft.banner.flow.red": "Красный поток",
  "block.minecraft.banner.flow.white": "Белый поток",
  "block.minecraft.banner.flow.yellow": "Жёлтый поток",
  "block.minecraft.banner.flower.black": "Чёрный цветок",
  "block.minecraft.banner.flower.blue": "Синий цветок",
  "block.minecraft.banner.flower.brown": "Коричневый цветок",
  "block.minecraft.banner.flower.cyan": "Бирюзовый цветок",
  "block.minecraft.banner.flower.gray": "Серый цветок",
  "block.minecraft.banner.flower.green": "Зелёный цветок",
  "block.minecraft.banner.flower.light_blue": "Голубой цветок",
  "block.minecraft.banner.flower.light_gray": "Светло-серый цветок",
  "block.minecraft.banner.flower.lime": "Лаймовый цветок",
  "block.minecraft.banner.flower.magenta": "Пурпурный цветок",
  "block.minecraft.banner.flower.orange": "Оранжевый цветок",
  "block.minecraft.banner.flower.pink": "Розовый цветок",
  "block.minecraft.banner.flower.purple": "Фиолетовый цветок",
  "block.minecraft.banner.flower.red": "Красный цветок",
  "block.minecraft.banner.flower.white": "Белый цветок",
  "block.minecraft.banner.flower.yellow": "Жёлтый цветок",
  "block.minecraft.banner.globe.black": "Чёрный глобус",
  "block.minecraft.banner.globe.blue": "Синий глобус",
  "block.minecraft.banner.globe.brown": "Коричневый глобус",
  "block.minecraft.banner.globe.cyan": "Бирюзовый глобус",
  "block.minecraft.banner.globe.gray": "Серый глобус",
  "block.minecraft.banner.globe.green": "Зелёный глобус",
  "block.minecraft.banner.globe.light_blue": "Голубой глобус",
  "block.minecraft.banner.globe.light_gray": "Светло-серый глобус",
  "block.minecraft.banner.globe.lime": "Лаймовый глобус",
  "block.minecraft.banner.globe.magenta": "Пурпурный глобус",
  "block.minecraft.banner.globe.orange": "Оранжевый глобус",
  "block.minecraft.banner.globe.pink": "Розовый глобус",
  "block.minecraft.banner.globe.purple": "Фиолетовый глобус",
  "block.minecraft.banner.globe.red": "Красный глобус",
  "block.minecraft.banner.globe.white": "Белый глобус",
  "block.minecraft.banner.globe.yellow": "Жёлтый глобус",
  "block.minecraft.banner.gradient.black": "Чёрный градиент",
  "block.minecraft.banner.gradient.blue": "Синий градиент",
  "block.minecraft.banner.gradient.brown": "Коричневый градиент",
  "block.minecraft.banner.gradient.cyan": "Бирюзовый градиент",
  "block.minecraft.banner.gradient.gray": "Серый градиент",
  "block.minecraft.banner.gradient.green": "Зелёный градиент",
  "block.minecraft.banner.gradient.light_blue": "Голубой градиент",
  "block.minecraft.banner.gradient.light_gray": "Светло-серый градиент",
  "block.minecraft.banner.gradient.lime": "Лаймовый градиент",
  "block.minecraft.banner.gradient.magenta": "Пурпурный градиент",
  "block.minecraft.banner.gradient.orange": "Оранжевый градиент",
  "block.minecraft.banner.gradient.pink": "Розовый градиент",
  "block.minecraft.banner.gradient.purple": "Фиолетовый градиент",
  "block.minecraft.banner.gradient.red": "Красный градиент",
  "block.minecraft.banner.gradient.white": "Белый градиент",
  "block.minecraft.banner.gradient.yellow": "Жёлтый градиент",
  "block.minecraft.banner.gradient_up.black": "Чёрный обратный градиент",
  "block.minecraft.banner.gradient_up.blue": "Синий обратный градиент",
  "block.minecraft.banner.gradient_up.brown": "Коричневый обратный градиент",
  "block.minecraft.banner.gradient_up.cyan": "Бирюзовый обратный градиент",
  "block.minecraft.banner.gradient_up.gray": "Серый обратный градиент",
  "block.minecraft.banner.gradient_up.green": "Зелёный обратный градиент",
  "block.minecraft.banner.gradient_up.light_blue": "Голубой обратный градиент",
  "block.minecraft.banner.gradient_up.light_gray": "Светло-серый обратный градиент",
  "block.minecraft.banner.gradient_up.lime": "Лаймовый обратный градиент",
  "block.minecraft.banner.gradient_up.magenta": "Пурпурный обратный градиент",
  "block.minecraft.banner.gradient_up.orange": "Оранжевый обратный градиент",
  "block.minecraft.banner.gradient_up.pink": "Розовый обратный градиент",
  "block.minecraft.banner.gradient_up.purple": "Фиолетовый обратный градиент",
  "block.minecraft.banner.gradient_up.red": "Красный обратный градиент",
  "block.minecraft.banner.gradient_up.white": "Белый обратный градиент",
  "block.minecraft.banner.gradient_up.yellow": "Жёлтый обратный градиент",
  "block.minecraft.banner.guster.black": "Чёрный вихрь",
  "block.minecraft.banner.guster.blue": "Синий вихрь",
  "block.minecraft.banner.guster.brown": "Коричневый вихрь",
  "block.minecraft.banner.guster.cyan": "Бирюзовый вихрь",
  "block.minecraft.banner.guster.gray": "Серый вихрь",
  "block.minecraft.banner.guster.green": "Зелёный вихрь",
  "block.minecraft.banner.guster.light_blue": "Голубой вихрь",
  "block.minecraft.banner.guster.light_gray": "Светло-серый вихрь",
  "block.minecraft.banner.guster.lime": "Лаймовый вихрь",
  "block.minecraft.banner.guster.magenta": "Пурпурный вихрь",
  "block.minecraft.banner.guster.orange": "Оранжевый вихрь",
  "block.minecraft.banner.guster.pink": "Розовый вихрь",
  "block.minecraft.banner.guster.purple": "Фиолетовый вихрь",
  "block.minecraft.banner.guster.red": "Красный вихрь",
  "block.minecraft.banner.guster.white": "Белый вихрь",
  "block.minecraft.banner.guster.yellow": "Жёлтый вихрь",
  "block.minecraft.banner.half_horizontal.black": "Чёрная верхняя половина",
  "block.minecraft.banner.half_horizontal.blue": "Синяя верхняя половина",
  "block.minecraft.banner.half_horizontal.brown": "Коричневая верхняя половина",
  "block.minecraft.banner.half_horizontal.cyan": "Бирюзовая верхняя половина",
  "block.minecraft.banner.half_horizontal.gray": "Серая верхняя половина",
  "block.minecraft.banner.half_horizontal.green": "Зелёная верхняя половина",
  "block.minecraft.banner.half_horizontal.light_blue": "Голубая верхняя половина",
  "block.minecraft.banner.half_horizontal.light_gray": "Светло-серая верхняя половина",
  "block.minecraft.banner.half_horizontal.lime": "Лаймовая верхняя половина",
  "block.minecraft.banner.half_horizontal.magenta": "Пурпурная верхняя половина",
  "block.minecraft.banner.half_horizontal.orange": "Оранжевая верхняя половина",
  "block.minecraft.banner.half_horizontal.pink": "Розовая верхняя половина",
  "block.minecraft.banner.half_horizontal.purple": "Фиолетовая верхняя половина",
  "block.minecraft.banner.half_horizontal.red": "Красная верхняя половина",
  "block.minecraft.banner.half_horizontal.white": "Белая верхняя половина",
  "block.minecraft.banner.half_horizontal.yellow": "Жёлтая верхняя половина",
  "block.minecraft.banner.half_horizontal_bottom.black": "Чёрная нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Синяя нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Коричневая нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Бирюзовая нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Серая нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.green": "Зелёная нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Голубая нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Светло-серая нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Лаймовая нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Пурпурная нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Оранжевая нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Розовая нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Фиолетовая нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.red": "Красная нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.white": "Белая нижняя половина",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Жёлтая нижняя половина",
  "block.minecraft.banner.half_vertical.black": "Чёрная правая половина",
  "block.minecraft.banner.half_vertical.blue": "Синяя правая половина",
  "block.minecraft.banner.half_vertical.brown": "Коричневая правая половина",
  "block.minecraft.banner.half_vertical.cyan": "Бирюзовая правая половина",
  "block.minecraft.banner.half_vertical.gray": "Серая правая половина",
  "block.minecraft.banner.half_vertical.green": "Зелёная правая половина",
  "block.minecraft.banner.half_vertical.light_blue": "Голубая правая половина",
  "block.minecraft.banner.half_vertical.light_gray": "Светло-серая правая половина",
  "block.minecraft.banner.half_vertical.lime": "Лаймовая правая половина",
  "block.minecraft.banner.half_vertical.magenta": "Пурпурная правая половина",
  "block.minecraft.banner.half_vertical.orange": "Оранжевая правая половина",
  "block.minecraft.banner.half_vertical.pink": "Розовая правая половина",
  "block.minecraft.banner.half_vertical.purple": "Фиолетовая правая половина",
  "block.minecraft.banner.half_vertical.red": "Красная правая половина",
  "block.minecraft.banner.half_vertical.white": "Белая правая половина",
  "block.minecraft.banner.half_vertical.yellow": "Жёлтая правая половина",
  "block.minecraft.banner.half_vertical_right.black": "Чёрная левая половина",
  "block.minecraft.banner.half_vertical_right.blue": "Синяя левая половина",
  "block.minecraft.banner.half_vertical_right.brown": "Коричневая левая половина",
  "block.minecraft.banner.half_vertical_right.cyan": "Бирюзовая левая половина",
  "block.minecraft.banner.half_vertical_right.gray": "Серая левая половина",
  "block.minecraft.banner.half_vertical_right.green": "Зелёная левая половина",
  "block.minecraft.banner.half_vertical_right.light_blue": "Голубая левая половина",
  "block.minecraft.banner.half_vertical_right.light_gray": "Светло-серая левая половина",
  "block.minecraft.banner.half_vertical_right.lime": "Лаймовая левая половина",
  "block.minecraft.banner.half_vertical_right.magenta": "Пурпурная левая половина",
  "block.minecraft.banner.half_vertical_right.orange": "Оранжевая левая половина",
  "block.minecraft.banner.half_vertical_right.pink": "Розовая левая половина",
  "block.minecraft.banner.half_vertical_right.purple": "Фиолетовая левая половина",
  "block.minecraft.banner.half_vertical_right.red": "Красная левая половина",
  "block.minecraft.banner.half_vertical_right.white": "Белая левая половина",
  "block.minecraft.banner.half_vertical_right.yellow": "Жёлтая левая половина",
  "block.minecraft.banner.mojang.black": "Чёрное нечто",
  "block.minecraft.banner.mojang.blue": "Синее нечто",
  "block.minecraft.banner.mojang.brown": "Коричневое нечто",
  "block.minecraft.banner.mojang.cyan": "Бирюзовое нечто",
  "block.minecraft.banner.mojang.gray": "Серое нечто",
  "block.minecraft.banner.mojang.green": "Зелёное нечто",
  "block.minecraft.banner.mojang.light_blue": "Голубое нечто",
  "block.minecraft.banner.mojang.light_gray": "Светло-серое нечто",
  "block.minecraft.banner.mojang.lime": "Лаймовое нечто",
  "block.minecraft.banner.mojang.magenta": "Пурпурное нечто",
  "block.minecraft.banner.mojang.orange": "Оранжевое нечто",
  "block.minecraft.banner.mojang.pink": "Розовое нечто",
  "block.minecraft.banner.mojang.purple": "Фиолетовое нечто",
  "block.minecraft.banner.mojang.red": "Красное нечто",
  "block.minecraft.banner.mojang.white": "Белое нечто",
  "block.minecraft.banner.mojang.yellow": "Жёлтое нечто",
  "block.minecraft.banner.piglin.black": "Чёрное рыло",
  "block.minecraft.banner.piglin.blue": "Синее рыло",
  "block.minecraft.banner.piglin.brown": "Коричневое рыло",
  "block.minecraft.banner.piglin.cyan": "Бирюзовое рыло",
  "block.minecraft.banner.piglin.gray": "Серое рыло",
  "block.minecraft.banner.piglin.green": "Зелёное рыло",
  "block.minecraft.banner.piglin.light_blue": "Голубое рыло",
  "block.minecraft.banner.piglin.light_gray": "Светло-серое рыло",
  "block.minecraft.banner.piglin.lime": "Лаймовое рыло",
  "block.minecraft.banner.piglin.magenta": "Пурпурное рыло",
  "block.minecraft.banner.piglin.orange": "Оранжевое рыло",
  "block.minecraft.banner.piglin.pink": "Розовое рыло",
  "block.minecraft.banner.piglin.purple": "Фиолетовое рыло",
  "block.minecraft.banner.piglin.red": "Красное рыло",
  "block.minecraft.banner.piglin.white": "Белое рыло",
  "block.minecraft.banner.piglin.yellow": "Жёлтое рыло",
  "block.minecraft.banner.rhombus.black": "Чёрный ромб",
  "block.minecraft.banner.rhombus.blue": "Синий ромб",
  "block.minecraft.banner.rhombus.brown": "Коричневый ромб",
  "block.minecraft.banner.rhombus.cyan": "Бирюзовый ромб",
  "block.minecraft.banner.rhombus.gray": "Серый ромб",
  "block.minecraft.banner.rhombus.green": "Зелёный ромб",
  "block.minecraft.banner.rhombus.light_blue": "Голубой ромб",
  "block.minecraft.banner.rhombus.light_gray": "Светло-серый ромб",
  "block.minecraft.banner.rhombus.lime": "Лаймовый ромб",
  "block.minecraft.banner.rhombus.magenta": "Пурпурный ромб",
  "block.minecraft.banner.rhombus.orange": "Оранжевый ромб",
  "block.minecraft.banner.rhombus.pink": "Розовый ромб",
  "block.minecraft.banner.rhombus.purple": "Фиолетовый ромб",
  "block.minecraft.banner.rhombus.red": "Красный ромб",
  "block.minecraft.banner.rhombus.white": "Белый ромб",
  "block.minecraft.banner.rhombus.yellow": "Жёлтый ромб",
  "block.minecraft.banner.skull.black": "Чёрный череп",
  "block.minecraft.banner.skull.blue": "Синий череп",
  "block.minecraft.banner.skull.brown": "Коричневый череп",
  "block.minecraft.banner.skull.cyan": "Бирюзовый череп",
  "block.minecraft.banner.skull.gray": "Серый череп",
  "block.minecraft.banner.skull.green": "Зелёный череп",
  "block.minecraft.banner.skull.light_blue": "Голубой череп",
  "block.minecraft.banner.skull.light_gray": "Светло-серый череп",
  "block.minecraft.banner.skull.lime": "Лаймовый череп",
  "block.minecraft.banner.skull.magenta": "Пурпурный череп",
  "block.minecraft.banner.skull.orange": "Оранжевый череп",
  "block.minecraft.banner.skull.pink": "Розовый череп",
  "block.minecraft.banner.skull.purple": "Фиолетовый череп",
  "block.minecraft.banner.skull.red": "Красный череп",
  "block.minecraft.banner.skull.white": "Белый череп",
  "block.minecraft.banner.skull.yellow": "Жёлтый череп",
  "block.minecraft.banner.small_stripes.black": "Чёрные столбы",
  "block.minecraft.banner.small_stripes.blue": "Синие столбы",
  "block.minecraft.banner.small_stripes.brown": "Коричневые столбы",
  "block.minecraft.banner.small_stripes.cyan": "Бирюзовые столбы",
  "block.minecraft.banner.small_stripes.gray": "Серые столбы",
  "block.minecraft.banner.small_stripes.green": "Зелёные столбы",
  "block.minecraft.banner.small_stripes.light_blue": "Голубые столбы",
  "block.minecraft.banner.small_stripes.light_gray": "Светло-серые столбы",
  "block.minecraft.banner.small_stripes.lime": "Лаймовые столбы",
  "block.minecraft.banner.small_stripes.magenta": "Пурпурные столбы",
  "block.minecraft.banner.small_stripes.orange": "Оранжевые столбы",
  "block.minecraft.banner.small_stripes.pink": "Розовые столбы",
  "block.minecraft.banner.small_stripes.purple": "Фиолетовые столбы",
  "block.minecraft.banner.small_stripes.red": "Красные столбы",
  "block.minecraft.banner.small_stripes.white": "Белые столбы",
  "block.minecraft.banner.small_stripes.yellow": "Жёлтые столбы",
  "block.minecraft.banner.square_bottom_left.black": "Чёрный нижний правый крыж",
  "block.minecraft.banner.square_bottom_left.blue": "Синий нижний правый крыж",
  "block.minecraft.banner.square_bottom_left.brown": "Коричневый нижний правый крыж",
  "block.minecraft.banner.square_bottom_left.cyan": "Бирюзовый нижний правый крыж",
  "block.minecraft.banner.square_bottom_left.gray": "Серый нижний правый крыж",
  "block.minecraft.banner.square_bottom_left.green": "Зелёный нижний правый крыж",
  "block.minecraft.banner.square_bottom_left.light_blue": "Голубой нижний правый крыж",
  "block.minecraft.banner.square_bottom_left.light_gray": "Светло-серый нижний правый крыж",
  "block.minecraft.banner.square_bottom_left.lime": "Лаймовый нижний правый крыж",
  "block.minecraft.banner.square_bottom_left.magenta": "Пурпурный нижний правый крыж",
  "block.minecraft.banner.square_bottom_left.orange": "Оранжевый нижний правый крыж",
  "block.minecraft.banner.square_bottom_left.pink": "Розовый нижний правый крыж",
  "block.minecraft.banner.square_bottom_left.purple": "Фиолетовый нижний правый крыж",
  "block.minecraft.banner.square_bottom_left.red": "Красный нижний правый крыж",
  "block.minecraft.banner.square_bottom_left.white": "Белый нижний правый крыж",
  "block.minecraft.banner.square_bottom_left.yellow": "Жёлтый нижний правый крыж",
  "block.minecraft.banner.square_bottom_right.black": "Чёрный нижний левый крыж",
  "block.minecraft.banner.square_bottom_right.blue": "Синий нижний левый крыж",
  "block.minecraft.banner.square_bottom_right.brown": "Коричневый нижний левый крыж",
  "block.minecraft.banner.square_bottom_right.cyan": "Бирюзовый нижний левый крыж",
  "block.minecraft.banner.square_bottom_right.gray": "Серый нижний левый крыж",
  "block.minecraft.banner.square_bottom_right.green": "Зелёный нижний левый крыж",
  "block.minecraft.banner.square_bottom_right.light_blue": "Голубой нижний левый крыж",
  "block.minecraft.banner.square_bottom_right.light_gray": "Светло-серый нижний левый крыж",
  "block.minecraft.banner.square_bottom_right.lime": "Лаймовый нижний левый крыж",
  "block.minecraft.banner.square_bottom_right.magenta": "Пурпурный нижний левый крыж",
  "block.minecraft.banner.square_bottom_right.orange": "Оранжевый нижний левый крыж",
  "block.minecraft.banner.square_bottom_right.pink": "Розовый нижний левый крыж",
  "block.minecraft.banner.square_bottom_right.purple": "Фиолетовый нижний левый крыж",
  "block.minecraft.banner.square_bottom_right.red": "Красный нижний левый крыж",
  "block.minecraft.banner.square_bottom_right.white": "Белый нижний левый крыж",
  "block.minecraft.banner.square_bottom_right.yellow": "Жёлтый нижний левый крыж",
  "block.minecraft.banner.square_top_left.black": "Чёрный верхний правый крыж",
  "block.minecraft.banner.square_top_left.blue": "Синий верхний правый крыж",
  "block.minecraft.banner.square_top_left.brown": "Коричневый верхний правый крыж",
  "block.minecraft.banner.square_top_left.cyan": "Бирюзовый верхний правый крыж",
  "block.minecraft.banner.square_top_left.gray": "Серый верхний правый крыж",
  "block.minecraft.banner.square_top_left.green": "Зелёный верхний правый крыж",
  "block.minecraft.banner.square_top_left.light_blue": "Голубой верхний правый крыж",
  "block.minecraft.banner.square_top_left.light_gray": "Светло-серый верхний правый крыж",
  "block.minecraft.banner.square_top_left.lime": "Лаймовый верхний правый крыж",
  "block.minecraft.banner.square_top_left.magenta": "Пурпурный верхний правый крыж",
  "block.minecraft.banner.square_top_left.orange": "Оранжевый верхний правый крыж",
  "block.minecraft.banner.square_top_left.pink": "Розовый верхний правый крыж",
  "block.minecraft.banner.square_top_left.purple": "Фиолетовый верхний правый крыж",
  "block.minecraft.banner.square_top_left.red": "Красный верхний правый крыж",
  "block.minecraft.banner.square_top_left.white": "Белый верхний правый крыж",
  "block.minecraft.banner.square_top_left.yellow": "Жёлтый верхний правый крыж",
  "block.minecraft.banner.square_top_right.black": "Чёрный верхний левый крыж",
  "block.minecraft.banner.square_top_right.blue": "Синий верхний левый крыж",
  "block.minecraft.banner.square_top_right.brown": "Коричневый верхний левый крыж",
  "block.minecraft.banner.square_top_right.cyan": "Бирюзовый верхний левый крыж",
  "block.minecraft.banner.square_top_right.gray": "Серый верхний левый крыж",
  "block.minecraft.banner.square_top_right.green": "Зелёный верхний левый крыж",
  "block.minecraft.banner.square_top_right.light_blue": "Голубой верхний левый крыж",
  "block.minecraft.banner.square_top_right.light_gray": "Светло-серый верхний левый крыж",
  "block.minecraft.banner.square_top_right.lime": "Лаймовый верхний левый крыж",
  "block.minecraft.banner.square_top_right.magenta": "Пурпурный верхний левый крыж",
  "block.minecraft.banner.square_top_right.orange": "Оранжевый верхний левый крыж",
  "block.minecraft.banner.square_top_right.pink": "Розовый верхний левый крыж",
  "block.minecraft.banner.square_top_right.purple": "Фиолетовый верхний левый крыж",
  "block.minecraft.banner.square_top_right.red": "Красный верхний левый крыж",
  "block.minecraft.banner.square_top_right.white": "Белый верхний левый крыж",
  "block.minecraft.banner.square_top_right.yellow": "Жёлтый верхний левый крыж",
  "block.minecraft.banner.straight_cross.black": "Чёрный крест",
  "block.minecraft.banner.straight_cross.blue": "Синий крест",
  "block.minecraft.banner.straight_cross.brown": "Коричневый крест",
  "block.minecraft.banner.straight_cross.cyan": "Бирюзовый крест",
  "block.minecraft.banner.straight_cross.gray": "Серый крест",
  "block.minecraft.banner.straight_cross.green": "Зелёный крест",
  "block.minecraft.banner.straight_cross.light_blue": "Голубой крест",
  "block.minecraft.banner.straight_cross.light_gray": "Светло-серый крест",
  "block.minecraft.banner.straight_cross.lime": "Лаймовый крест",
  "block.minecraft.banner.straight_cross.magenta": "Пурпурный крест",
  "block.minecraft.banner.straight_cross.orange": "Оранжевый крест",
  "block.minecraft.banner.straight_cross.pink": "Розовый крест",
  "block.minecraft.banner.straight_cross.purple": "Фиолетовый крест",
  "block.minecraft.banner.straight_cross.red": "Красный крест",
  "block.minecraft.banner.straight_cross.white": "Белый крест",
  "block.minecraft.banner.straight_cross.yellow": "Жёлтый крест",
  "block.minecraft.banner.stripe_bottom.black": "Чёрное основание",
  "block.minecraft.banner.stripe_bottom.blue": "Синее основание",
  "block.minecraft.banner.stripe_bottom.brown": "Коричневое основание",
  "block.minecraft.banner.stripe_bottom.cyan": "Бирюзовое основание",
  "block.minecraft.banner.stripe_bottom.gray": "Серое основание",
  "block.minecraft.banner.stripe_bottom.green": "Зелёное основание",
  "block.minecraft.banner.stripe_bottom.light_blue": "Голубое основание",
  "block.minecraft.banner.stripe_bottom.light_gray": "Светло-серое основание",
  "block.minecraft.banner.stripe_bottom.lime": "Лаймовое основание",
  "block.minecraft.banner.stripe_bottom.magenta": "Пурпурное основание",
  "block.minecraft.banner.stripe_bottom.orange": "Оранжевое основание",
  "block.minecraft.banner.stripe_bottom.pink": "Розовое основание",
  "block.minecraft.banner.stripe_bottom.purple": "Фиолетовое основание",
  "block.minecraft.banner.stripe_bottom.red": "Красное основание",
  "block.minecraft.banner.stripe_bottom.white": "Белое основание",
  "block.minecraft.banner.stripe_bottom.yellow": "Жёлтое основание",
  "block.minecraft.banner.stripe_center.black": "Чёрный столб",
  "block.minecraft.banner.stripe_center.blue": "Синий столб",
  "block.minecraft.banner.stripe_center.brown": "Коричневый столб",
  "block.minecraft.banner.stripe_center.cyan": "Бирюзовый столб",
  "block.minecraft.banner.stripe_center.gray": "Серый столб",
  "block.minecraft.banner.stripe_center.green": "Зелёный столб",
  "block.minecraft.banner.stripe_center.light_blue": "Голубой столб",
  "block.minecraft.banner.stripe_center.light_gray": "Светло-серый столб",
  "block.minecraft.banner.stripe_center.lime": "Лаймовый столб",
  "block.minecraft.banner.stripe_center.magenta": "Пурпурный столб",
  "block.minecraft.banner.stripe_center.orange": "Оранжевый столб",
  "block.minecraft.banner.stripe_center.pink": "Розовый столб",
  "block.minecraft.banner.stripe_center.purple": "Фиолетовый столб",
  "block.minecraft.banner.stripe_center.red": "Красный столб",
  "block.minecraft.banner.stripe_center.white": "Белый столб",
  "block.minecraft.banner.stripe_center.yellow": "Жёлтый столб",
  "block.minecraft.banner.stripe_downleft.black": "Чёрная левосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.blue": "Синяя левосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.brown": "Коричневая левосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.cyan": "Бирюзовая левосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.gray": "Серая левосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.green": "Зелёная левосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.light_blue": "Голубая левосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.light_gray": "Светло-серая левосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.lime": "Лаймовая левосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.magenta": "Пурпурная левосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.orange": "Оранжевая левосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.pink": "Розовая левосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.purple": "Фиолетовая левосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.red": "Красная левосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.white": "Белая левосторонняя перевязь",
  "block.minecraft.banner.stripe_downleft.yellow": "Жёлтая левосторонняя перевязь",
  "block.minecraft.banner.stripe_downright.black": "Чёрная перевязь",
  "block.minecraft.banner.stripe_downright.blue": "Синяя перевязь",
  "block.minecraft.banner.stripe_downright.brown": "Коричневая перевязь",
  "block.minecraft.banner.stripe_downright.cyan": "Бирюзовая перевязь",
  "block.minecraft.banner.stripe_downright.gray": "Серая перевязь",
  "block.minecraft.banner.stripe_downright.green": "Зелёная перевязь",
  "block.minecraft.banner.stripe_downright.light_blue": "Голубая перевязь",
  "block.minecraft.banner.stripe_downright.light_gray": "Светло-серая перевязь",
  "block.minecraft.banner.stripe_downright.lime": "Лаймовая перевязь",
  "block.minecraft.banner.stripe_downright.magenta": "Пурпурная перевязь",
  "block.minecraft.banner.stripe_downright.orange": "Оранжевая перевязь",
  "block.minecraft.banner.stripe_downright.pink": "Розовая перевязь",
  "block.minecraft.banner.stripe_downright.purple": "Фиолетовая перевязь",
  "block.minecraft.banner.stripe_downright.red": "Красная перевязь",
  "block.minecraft.banner.stripe_downright.white": "Белая перевязь",
  "block.minecraft.banner.stripe_downright.yellow": "Жёлтая перевязь",
  "block.minecraft.banner.stripe_left.black": "Чёрный правосторонний столб",
  "block.minecraft.banner.stripe_left.blue": "Синий правосторонний столб",
  "block.minecraft.banner.stripe_left.brown": "Коричневый правосторонний столб",
  "block.minecraft.banner.stripe_left.cyan": "Бирюзовый правосторонний столб",
  "block.minecraft.banner.stripe_left.gray": "Серый правосторонний столб",
  "block.minecraft.banner.stripe_left.green": "Зелёный правосторонний столб",
  "block.minecraft.banner.stripe_left.light_blue": "Голубой правосторонний столб",
  "block.minecraft.banner.stripe_left.light_gray": "Светло-серый правосторонний столб",
  "block.minecraft.banner.stripe_left.lime": "Лаймовый правосторонний столб",
  "block.minecraft.banner.stripe_left.magenta": "Пурпурный правосторонний столб",
  "block.minecraft.banner.stripe_left.orange": "Оранжевый правосторонний столб",
  "block.minecraft.banner.stripe_left.pink": "Розовый правосторонний столб",
  "block.minecraft.banner.stripe_left.purple": "Фиолетовый правосторонний столб",
  "block.minecraft.banner.stripe_left.red": "Красный правосторонний столб",
  "block.minecraft.banner.stripe_left.white": "Белый правосторонний столб",
  "block.minecraft.banner.stripe_left.yellow": "Жёлтый правосторонний столб",
  "block.minecraft.banner.stripe_middle.black": "Чёрный пояс",
  "block.minecraft.banner.stripe_middle.blue": "Синий пояс",
  "block.minecraft.banner.stripe_middle.brown": "Коричневый пояс",
  "block.minecraft.banner.stripe_middle.cyan": "Бирюзовый пояс",
  "block.minecraft.banner.stripe_middle.gray": "Серый пояс",
  "block.minecraft.banner.stripe_middle.green": "Зелёный пояс",
  "block.minecraft.banner.stripe_middle.light_blue": "Голубой пояс",
  "block.minecraft.banner.stripe_middle.light_gray": "Светло-серый пояс",
  "block.minecraft.banner.stripe_middle.lime": "Лаймовый пояс",
  "block.minecraft.banner.stripe_middle.magenta": "Пурпурный пояс",
  "block.minecraft.banner.stripe_middle.orange": "Оранжевый пояс",
  "block.minecraft.banner.stripe_middle.pink": "Розовый пояс",
  "block.minecraft.banner.stripe_middle.purple": "Фиолетовый пояс",
  "block.minecraft.banner.stripe_middle.red": "Красный пояс",
  "block.minecraft.banner.stripe_middle.white": "Белый пояс",
  "block.minecraft.banner.stripe_middle.yellow": "Жёлтый пояс",
  "block.minecraft.banner.stripe_right.black": "Чёрный левосторонний столб",
  "block.minecraft.banner.stripe_right.blue": "Синий левосторонний столб",
  "block.minecraft.banner.stripe_right.brown": "Коричневый левосторонний столб",
  "block.minecraft.banner.stripe_right.cyan": "Бирюзовый левосторонний столб",
  "block.minecraft.banner.stripe_right.gray": "Серый левосторонний столб",
  "block.minecraft.banner.stripe_right.green": "Зелёный левосторонний столб",
  "block.minecraft.banner.stripe_right.light_blue": "Голубой левосторонний столб",
  "block.minecraft.banner.stripe_right.light_gray": "Светло-серый левосторонний столб",
  "block.minecraft.banner.stripe_right.lime": "Лаймовый левосторонний столб",
  "block.minecraft.banner.stripe_right.magenta": "Пурпурный левосторонний столб",
  "block.minecraft.banner.stripe_right.orange": "Оранжевый левосторонний столб",
  "block.minecraft.banner.stripe_right.pink": "Розовый левосторонний столб",
  "block.minecraft.banner.stripe_right.purple": "Фиолетовый левосторонний столб",
  "block.minecraft.banner.stripe_right.red": "Красный левосторонний столб",
  "block.minecraft.banner.stripe_right.white": "Белый левосторонний столб",
  "block.minecraft.banner.stripe_right.yellow": "Жёлтый левосторонний столб",
  "block.minecraft.banner.stripe_top.black": "Чёрная глава",
  "block.minecraft.banner.stripe_top.blue": "Синяя глава",
  "block.minecraft.banner.stripe_top.brown": "Коричневая глава",
  "block.minecraft.banner.stripe_top.cyan": "Бирюзовая глава",
  "block.minecraft.banner.stripe_top.gray": "Серая глава",
  "block.minecraft.banner.stripe_top.green": "Зелёная глава",
  "block.minecraft.banner.stripe_top.light_blue": "Голубая глава",
  "block.minecraft.banner.stripe_top.light_gray": "Светло-серая глава",
  "block.minecraft.banner.stripe_top.lime": "Лаймовая глава",
  "block.minecraft.banner.stripe_top.magenta": "Пурпурная глава",
  "block.minecraft.banner.stripe_top.orange": "Оранжевая глава",
  "block.minecraft.banner.stripe_top.pink": "Розовая глава",
  "block.minecraft.banner.stripe_top.purple": "Фиолетовая глава",
  "block.minecraft.banner.stripe_top.red": "Красная глава",
  "block.minecraft.banner.stripe_top.white": "Белая глава",
  "block.minecraft.banner.stripe_top.yellow": "Жёлтая глава",
  "block.minecraft.banner.triangle_bottom.black": "Чёрное остриё",
  "block.minecraft.banner.triangle_bottom.blue": "Синее остриё",
  "block.minecraft.banner.triangle_bottom.brown": "Коричневое остриё",
  "block.minecraft.banner.triangle_bottom.cyan": "Бирюзовое остриё",
  "block.minecraft.banner.triangle_bottom.gray": "Серое остриё",
  "block.minecraft.banner.triangle_bottom.green": "Зелёное остриё",
  "block.minecraft.banner.triangle_bottom.light_blue": "Голубое остриё",
  "block.minecraft.banner.triangle_bottom.light_gray": "Светло-серое остриё",
  "block.minecraft.banner.triangle_bottom.lime": "Лаймовое остриё",
  "block.minecraft.banner.triangle_bottom.magenta": "Пурпурное остриё",
  "block.minecraft.banner.triangle_bottom.orange": "Оранжевое остриё",
  "block.minecraft.banner.triangle_bottom.pink": "Розовое остриё",
  "block.minecraft.banner.triangle_bottom.purple": "Фиолетовое остриё",
  "block.minecraft.banner.triangle_bottom.red": "Красное остриё",
  "block.minecraft.banner.triangle_bottom.white": "Белое остриё",
  "block.minecraft.banner.triangle_bottom.yellow": "Жёлтое остриё",
  "block.minecraft.banner.triangle_top.black": "Чёрное опрокинутое остриё",
  "block.minecraft.banner.triangle_top.blue": "Синее опрокинутое остриё",
  "block.minecraft.banner.triangle_top.brown": "Коричневое опрокинутое остриё",
  "block.minecraft.banner.triangle_top.cyan": "Бирюзовое опрокинутое остриё",
  "block.minecraft.banner.triangle_top.gray": "Серое опрокинутое остриё",
  "block.minecraft.banner.triangle_top.green": "Зелёное опрокинутое остриё",
  "block.minecraft.banner.triangle_top.light_blue": "Голубое опрокинутое остриё",
  "block.minecraft.banner.triangle_top.light_gray": "Светло-серое опрокинутое остриё",
  "block.minecraft.banner.triangle_top.lime": "Лаймовое опрокинутое остриё",
  "block.minecraft.banner.triangle_top.magenta": "Пурпурное опрокинутое остриё",
  "block.minecraft.banner.triangle_top.orange": "Оранжевое опрокинутое остриё",
  "block.minecraft.banner.triangle_top.pink": "Розовое опрокинутое остриё",
  "block.minecraft.banner.triangle_top.purple": "Фиолетовое опрокинутое остриё",
  "block.minecraft.banner.triangle_top.red": "Красное опрокинутое остриё",
  "block.minecraft.banner.triangle_top.white": "Белое опрокинутое остриё",
  "block.minecraft.banner.triangle_top.yellow": "Жёлтое опрокинутое остриё",
  "block.minecraft.banner.triangles_bottom.black": "Чёрное зубчатое основание",
  "block.minecraft.banner.triangles_bottom.blue": "Синее зубчатое основание",
  "block.minecraft.banner.triangles_bottom.brown": "Коричневое зубчатое основание",
  "block.minecraft.banner.triangles_bottom.cyan": "Бирюзовое зубчатое основание",
  "block.minecraft.banner.triangles_bottom.gray": "Серое зубчатое основание",
  "block.minecraft.banner.triangles_bottom.green": "Зелёное зубчатое основание",
  "block.minecraft.banner.triangles_bottom.light_blue": "Голубое зубчатое основание",
  "block.minecraft.banner.triangles_bottom.light_gray": "Светло-серое зубчатое основание",
  "block.minecraft.banner.triangles_bottom.lime": "Лаймовое зубчатое основание",
  "block.minecraft.banner.triangles_bottom.magenta": "Пурпурное зубчатое основание",
  "block.minecraft.banner.triangles_bottom.orange": "Оранжевое зубчатое основание",
  "block.minecraft.banner.triangles_bottom.pink": "Розовое зубчатое основание",
  "block.minecraft.banner.triangles_bottom.purple": "Фиолетовое зубчатое основание",
  "block.minecraft.banner.triangles_bottom.red": "Красное зубчатое основание",
  "block.minecraft.banner.triangles_bottom.white": "Белое зубчатое основание",
  "block.minecraft.banner.triangles_bottom.yellow": "Жёлтое зубчатое основание",
  "block.minecraft.banner.triangles_top.black": "Чёрная зубчатая глава",
  "block.minecraft.banner.triangles_top.blue": "Синяя зубчатая глава",
  "block.minecraft.banner.triangles_top.brown": "Коричневая зубчатая глава",
  "block.minecraft.banner.triangles_top.cyan": "Бирюзовая зубчатая глава",
  "block.minecraft.banner.triangles_top.gray": "Серая зубчатая глава",
  "block.minecraft.banner.triangles_top.green": "Зелёная зубчатая глава",
  "block.minecraft.banner.triangles_top.light_blue": "Голубая зубчатая глава",
  "block.minecraft.banner.triangles_top.light_gray": "Светло-серая зубчатая глава",
  "block.minecraft.banner.triangles_top.lime": "Лаймовая зубчатая глава",
  "block.minecraft.banner.triangles_top.magenta": "Пурпурная зубчатая глава",
  "block.minecraft.banner.triangles_top.orange": "Оранжевая зубчатая глава",
  "block.minecraft.banner.triangles_top.pink": "Розовая зубчатая глава",
  "block.minecraft.banner.triangles_top.purple": "Фиолетовая зубчатая глава",
  "block.minecraft.banner.triangles_top.red": "Красная зубчатая глава",
  "block.minecraft.banner.triangles_top.white": "Белая зубчатая глава",
  "block.minecraft.banner.triangles_top.yellow": "Жёлтая зубчатая глава",
  "block.minecraft.barrel": "Бочка",
  "block.minecraft.barrier": "Барьер",
  "block.minecraft.basalt": "Базальт",
  "block.minecraft.beacon": "Маяк",
  "block.minecraft.beacon.primary": "Основной эффект",
  "block.minecraft.beacon.secondary": "Вторичный эффект",
  "block.minecraft.bed.no_sleep": "Вы можете спать только ночью или во время грозы",
  "block.minecraft.bed.not_safe": "Вы не можете уснуть, пока рядом есть монстры",
  "block.minecraft.bed.obstructed": "Эта кровать заблокирована",
  "block.minecraft.bed.occupied": "Эта кровать занята",
  "block.minecraft.bed.too_far_away": "Вы не можете уснуть, кровать слишком далеко",
  "block.minecraft.bedrock": "Бедрок",
  "block.minecraft.bee_nest": "Пчелиное гнездо",
  "block.minecraft.beehive": "Улей",
  "block.minecraft.beetroots": "Свёкла",
  "block.minecraft.bell": "Колокол",
  "block.minecraft.big_dripleaf": "Большая бросянка",
  "block.minecraft.big_dripleaf_stem": "Стебель большой бросянки",
  "block.minecraft.birch_button": "Берёзовая кнопка",
  "block.minecraft.birch_door": "Берёзовая дверь",
  "block.minecraft.birch_fence": "Берёзовый забор",
  "block.minecraft.birch_fence_gate": "Берёзовая калитка",
  "block.minecraft.birch_hanging_sign": "Берёзовая подвесная табличка",
  "block.minecraft.birch_leaves": "Берёзовые листья",
  "block.minecraft.birch_log": "Берёзовое бревно",
  "block.minecraft.birch_planks": "Берёзовые доски",
  "block.minecraft.birch_pressure_plate": "Берёзовая нажимная плита",
  "block.minecraft.birch_sapling": "Саженец берёзы",
  "block.minecraft.birch_shelf": "Берёзовая полка",
  "block.minecraft.birch_sign": "Берёзовая табличка",
  "block.minecraft.birch_slab": "Берёзовая плита",
  "block.minecraft.birch_stairs": "Берёзовые ступеньки",
  "block.minecraft.birch_trapdoor": "Берёзовый люк",
  "block.minecraft.birch_wall_hanging_sign": "Берёзовая настенная подвесная табличка",
  "block.minecraft.birch_wall_sign": "Берёзовая настенная табличка",
  "block.minecraft.birch_wood": "Берёза",
  "block.minecraft.black_banner": "Чёрный флаг",
  "block.minecraft.black_bed": "Чёрная кровать",
  "block.minecraft.black_candle": "Чёрная свеча",
  "block.minecraft.black_candle_cake": "Торт с чёрной свечой",
  "block.minecraft.black_carpet": "Чёрный ковёр",
  "block.minecraft.black_concrete": "Чёрный бетон",
  "block.minecraft.black_concrete_powder": "Чёрный сухой бетон",
  "block.minecraft.black_glazed_terracotta": "Чёрная глазурованная керамика",
  "block.minecraft.black_shulker_box": "Чёрный шалкеровый ящик",
  "block.minecraft.black_stained_glass": "Чёрное стекло",
  "block.minecraft.black_stained_glass_pane": "Чёрная стеклянная панель",
  "block.minecraft.black_terracotta": "Чёрная керамика",
  "block.minecraft.black_wool": "Чёрная шерсть",
  "block.minecraft.blackstone": "Чернит",
  "block.minecraft.blackstone_slab": "Чернитная плита",
  "block.minecraft.blackstone_stairs": "Чернитные ступеньки",
  "block.minecraft.blackstone_wall": "Чернитная ограда",
  "block.minecraft.blast_furnace": "Плавильная печь",
  "block.minecraft.blue_banner": "Синий флаг",
  "block.minecraft.blue_bed": "Синяя кровать",
  "block.minecraft.blue_candle": "Синяя свеча",
  "block.minecraft.blue_candle_cake": "Торт с синей свечой",
  "block.minecraft.blue_carpet": "Синий ковёр",
  "block.minecraft.blue_concrete": "Синий бетон",
  "block.minecraft.blue_concrete_powder": "Синий сухой бетон",
  "block.minecraft.blue_glazed_terracotta": "Синяя глазурованная керамика",
  "block.minecraft.blue_ice": "Синий лёд",
  "block.minecraft.blue_orchid": "Синяя орхидея",
  "block.minecraft.blue_shulker_box": "Синий шалкеровый ящик",
  "block.minecraft.blue_stained_glass": "Синее стекло",
  "block.minecraft.blue_stained_glass_pane": "Синяя стеклянная панель",
  "block.minecraft.blue_terracotta": "Синяя керамика",
  "block.minecraft.blue_wool": "Синяя шерсть",
  "block.minecraft.bone_block": "Костный блок",
  "block.minecraft.bookshelf": "Книжная полка",
  "block.minecraft.brain_coral": "Коралл-мозговик",
  "block.minecraft.brain_coral_block": "Блок коралла-мозговика",
  "block.minecraft.brain_coral_fan": "Веерный коралл-мозговик",
  "block.minecraft.brain_coral_wall_fan": "Горизонтальный веерный коралл-мозговик",
  "block.minecraft.brewing_stand": "Зельеварка",
  "block.minecraft.brick_slab": "Кирпичная плита",
  "block.minecraft.brick_stairs": "Кирпичные ступеньки",
  "block.minecraft.brick_wall": "Кирпичная ограда",
  "block.minecraft.bricks": "Кирпичи",
  "block.minecraft.brown_banner": "Коричневый флаг",
  "block.minecraft.brown_bed": "Коричневая кровать",
  "block.minecraft.brown_candle": "Коричневая свеча",
  "block.minecraft.brown_candle_cake": "Торт с коричневой свечой",
  "block.minecraft.brown_carpet": "Коричневый ковёр",
  "block.minecraft.brown_concrete": "Коричневый бетон",
  "block.minecraft.brown_concrete_powder": "Коричневый сухой бетон",
  "block.minecraft.brown_glazed_terracotta": "Коричневая глазурованная керамика",
  "block.minecraft.brown_mushroom": "Коричневый гриб",
  "block.minecraft.brown_mushroom_block": "Блок коричневого гриба",
  "block.minecraft.brown_shulker_box": "Коричневый шалкеровый ящик",
  "block.minecraft.brown_stained_glass": "Коричневое стекло",
  "block.minecraft.brown_stained_glass_pane": "Коричневая стеклянная панель",
  "block.minecraft.brown_terracotta": "Коричневая керамика",
  "block.minecraft.brown_wool": "Коричневая шерсть",
  "block.minecraft.bubble_column": "Колонна пузырей",
  "block.minecraft.bubble_coral": "Пузырчатый коралл",
  "block.minecraft.bubble_coral_block": "Блок пузырчатого коралла",
  "block.minecraft.bubble_coral_fan": "Веерный пузырчатый коралл",
  "block.minecraft.bubble_coral_wall_fan": "Горизонтальный веерный пузырчатый коралл",
  "block.minecraft.budding_amethyst": "Цветущий аметист",
  "block.minecraft.bush": "Куст",
  "block.minecraft.cactus": "Кактус",
  "block.minecraft.cactus_flower": "Цветок кактуса",
  "block.minecraft.cake": "Торт",
  "block.minecraft.calcite": "Кальцит",
  "block.minecraft.calibrated_sculk_sensor": "Откалиброванный скалк-сенсор",
  "block.minecraft.campfire": "Костёр",
  "block.minecraft.candle": "Свеча",
  "block.minecraft.candle_cake": "Торт со свечой",
  "block.minecraft.carrots": "Морковь",
  "block.minecraft.cartography_table": "Стол картографа",
  "block.minecraft.carved_pumpkin": "Вырезанная тыква",
  "block.minecraft.cauldron": "Котёл",
  "block.minecraft.cave_air": "Пещерный воздух",
  "block.minecraft.cave_vines": "Пещерная лоза",
  "block.minecraft.cave_vines_plant": "Стебель пещерной лозы",
  "block.minecraft.chain": "Цепь",
  "block.minecraft.chain_command_block": "Последовательный командный блок",
  "block.minecraft.cherry_button": "Вишнёвая кнопка",
  "block.minecraft.cherry_door": "Вишнёвая дверь",
  "block.minecraft.cherry_fence": "Вишнёвый забор",
  "block.minecraft.cherry_fence_gate": "Вишнёвая калитка",
  "block.minecraft.cherry_hanging_sign": "Вишнёвая подвесная табличка",
  "block.minecraft.cherry_leaves": "Вишнёвые листья",
  "block.minecraft.cherry_log": "Вишнёвое бревно",
  "block.minecraft.cherry_planks": "Вишнёвые доски",
  "block.minecraft.cherry_pressure_plate": "Вишнёвая нажимная плита",
  "block.minecraft.cherry_sapling": "Саженец вишни",
  "block.minecraft.cherry_shelf": "Вишнёвая полка",
  "block.minecraft.cherry_sign": "Вишнёвая табличка",
  "block.minecraft.cherry_slab": "Вишнёвая плита",
  "block.minecraft.cherry_stairs": "Вишнёвые ступеньки",
  "block.minecraft.cherry_trapdoor": "Вишнёвый люк",
  "block.minecraft.cherry_wall_hanging_sign": "Вишнёвая настенная подвесная табличка",
  "block.minecraft.cherry_wall_sign": "Вишнёвая настенная табличка",
  "block.minecraft.cherry_wood": "Вишня",
  "block.minecraft.chest": "Сундук",
  "block.minecraft.chipped_anvil": "Повреждённая наковальня",
  "block.minecraft.chiseled_bookshelf": "Резная книжная полка",
  "block.minecraft.chiseled_copper": "Точёный медный блок",
  "block.minecraft.chiseled_deepslate": "Резной глубинный сланец",
  "block.minecraft.chiseled_nether_bricks": "Резные незерские кирпичи",
  "block.minecraft.chiseled_polished_blackstone": "Резной полированный чернит",
  "block.minecraft.chiseled_quartz_block": "Резной кварцевый блок",
  "block.minecraft.chiseled_red_sandstone": "Резной красный песчаник",
  "block.minecraft.chiseled_resin_bricks": "Резные смоляные кирпичи",
  "block.minecraft.chiseled_sandstone": "Резной песчаник",
  "block.minecraft.chiseled_stone_bricks": "Резные каменные кирпичи",
  "block.minecraft.chiseled_tuff": "Резной туф",
  "block.minecraft.chiseled_tuff_bricks": "Резные туфовые кирпичи",
  "block.minecraft.chorus_flower": "Цветок хоруса",
  "block.minecraft.chorus_plant": "Хорус",
  "block.minecraft.clay": "Глина",
  "block.minecraft.closed_eyeblossom": "Закрытая глазалия",
  "block.minecraft.coal_block": "Угольный блок",
  "block.minecraft.coal_ore": "Угольная руда",
  "block.minecraft.coarse_dirt": "Каменистая земля",
  "block.minecraft.cobbled_deepslate": "Колотый глубинный сланец",
  "block.minecraft.cobbled_deepslate_slab": "Плита из колотого глубинного сланца",
  "block.minecraft.cobbled_deepslate_stairs": "Ступеньки из колотого глубинного сланца",
  "block.minecraft.cobbled_deepslate_wall": "Ограда из колотого глубинного сланца",
  "block.minecraft.cobblestone": "Булыжник",
  "block.minecraft.cobblestone_slab": "Булыжная плита",
  "block.minecraft.cobblestone_stairs": "Булыжные ступеньки",
  "block.minecraft.cobblestone_wall": "Булыжная ограда",
  "block.minecraft.cobweb": "Паутина",
  "block.minecraft.cocoa": "Какао",
  "block.minecraft.command_block": "Командный блок",
  "block.minecraft.comparator": "Редстоуновый компаратор",
  "block.minecraft.composter": "Компостница",
  "block.minecraft.conduit": "Морской источник",
  "block.minecraft.copper_bars": "Медные прутья",
  "block.minecraft.copper_block": "Медный блок",
  "block.minecraft.copper_bulb": "Медная лампа",
  "block.minecraft.copper_chain": "Медная цепь",
  "block.minecraft.copper_chest": "Медный сундук",
  "block.minecraft.copper_door": "Медная дверь",
  "block.minecraft.copper_golem_statue": "Статуя медного голема",
  "block.minecraft.copper_grate": "Медная решётка",
  "block.minecraft.copper_lantern": "Медный фонарь",
  "block.minecraft.copper_ore": "Медная руда",
  "block.minecraft.copper_torch": "Медный факел",
  "block.minecraft.copper_trapdoor": "Медный люк",
  "block.minecraft.copper_wall_torch": "Настенный медный факел",
  "block.minecraft.cornflower": "Синий василёк",
  "block.minecraft.cracked_deepslate_bricks": "Потрескавшиеся глубинносланцевые кирпичи",
  "block.minecraft.cracked_deepslate_tiles": "Потрескавшийся глубинносланцевый плитняк",
  "block.minecraft.cracked_nether_bricks": "Потрескавшиеся незерские кирпичи",
  "block.minecraft.cracked_polished_blackstone_bricks": "Потрескавшиеся полированно-чернитные кирпичи",
  "block.minecraft.cracked_stone_bricks": "Потрескавшиеся каменные кирпичи",
  "block.minecraft.crafter": "Сборщик",
  "block.minecraft.crafting_table": "Верстак",
  "block.minecraft.creaking_heart": "Скрипцевина",
  "block.minecraft.creeper_head": "Голова крипера",
  "block.minecraft.creeper_wall_head": "Настенная голова крипера",
  "block.minecraft.crimson_button": "Багровая кнопка",
  "block.minecraft.crimson_door": "Багровая дверь",
  "block.minecraft.crimson_fence": "Багровый забор",
  "block.minecraft.crimson_fence_gate": "Багровая калитка",
  "block.minecraft.crimson_fungus": "Багровый гриб",
  "block.minecraft.crimson_hanging_sign": "Багровая подвесная табличка",
  "block.minecraft.crimson_hyphae": "Багровые гифы",
  "block.minecraft.crimson_nylium": "Багровый нилий",
  "block.minecraft.crimson_planks": "Багровые доски",
  "block.minecraft.crimson_pressure_plate": "Багровая нажимная плита",
  "block.minecraft.crimson_roots": "Багровые корни",
  "block.minecraft.crimson_shelf": "Багровая полка",
  "block.minecraft.crimson_sign": "Багровая табличка",
  "block.minecraft.crimson_slab": "Багровая плита",
  "block.minecraft.crimson_stairs": "Багровые ступеньки",
  "block.minecraft.crimson_stem": "Багровый стебель",
  "block.minecraft.crimson_trapdoor": "Багровый люк",
  "block.minecraft.crimson_wall_hanging_sign": "Багровая настенная подвесная табличка",
  "block.minecraft.crimson_wall_sign": "Багровая настенная табличка",
  "block.minecraft.crying_obsidian": "Плачущий обсидиан",
  "block.minecraft.cut_copper": "Резной медный блок",
  "block.minecraft.cut_copper_slab": "Резная медная плита",
  "block.minecraft.cut_copper_stairs": "Резные медные ступеньки",
  "block.minecraft.cut_red_sandstone": "Пиленый красный песчаник",
  "block.minecraft.cut_red_sandstone_slab": "Плита из пиленого красного песчаника",
  "block.minecraft.cut_sandstone": "Пиленый песчаник",
  "block.minecraft.cut_sandstone_slab": "Плита из пиленого песчаника",
  "block.minecraft.cyan_banner": "Бирюзовый флаг",
  "block.minecraft.cyan_bed": "Бирюзовая кровать",
  "block.minecraft.cyan_candle": "Бирюзовая свеча",
  "block.minecraft.cyan_candle_cake": "Торт с бирюзовой свечой",
  "block.minecraft.cyan_carpet": "Бирюзовый ковёр",
  "block.minecraft.cyan_concrete": "Бирюзовый бетон",
  "block.minecraft.cyan_concrete_powder": "Бирюзовый сухой бетон",
  "block.minecraft.cyan_glazed_terracotta": "Бирюзовая глазурованная керамика",
  "block.minecraft.cyan_shulker_box": "Бирюзовый шалкеровый ящик",
  "block.minecraft.cyan_stained_glass": "Бирюзовое стекло",
  "block.minecraft.cyan_stained_glass_pane": "Бирюзовая стеклянная панель",
  "block.minecraft.cyan_terracotta": "Бирюзовая керамика",
  "block.minecraft.cyan_wool": "Бирюзовая шерсть",
  "block.minecraft.damaged_anvil": "Разбитая наковальня",
  "block.minecraft.dandelion": "Одуванчик",
  "block.minecraft.dark_oak_button": "Кнопка из тёмного дуба",
  "block.minecraft.dark_oak_door": "Дверь из тёмного дуба",
  "block.minecraft.dark_oak_fence": "Забор из тёмного дуба",
  "block.minecraft.dark_oak_fence_gate": "Калитка из тёмного дуба",
  "block.minecraft.dark_oak_hanging_sign": "Подвесная табличка из тёмного дуба",
  "block.minecraft.dark_oak_leaves": "Листья тёмного дуба",
  "block.minecraft.dark_oak_log": "Бревно тёмного дуба",
  "block.minecraft.dark_oak_planks": "Доски из тёмного дуба",
  "block.minecraft.dark_oak_pressure_plate": "Нажимная плита из тёмного дуба",
  "block.minecraft.dark_oak_sapling": "Саженец тёмного дуба",
  "block.minecraft.dark_oak_shelf": "Полка из тёмного дуба",
  "block.minecraft.dark_oak_sign": "Табличка из тёмного дуба",
  "block.minecraft.dark_oak_slab": "Плита из тёмного дуба",
  "block.minecraft.dark_oak_stairs": "Ступеньки из тёмного дуба",
  "block.minecraft.dark_oak_trapdoor": "Люк из тёмного дуба",
  "block.minecraft.dark_oak_wall_hanging_sign": "Настенная подвесная табличка из тёмного дуба",
  "block.minecraft.dark_oak_wall_sign": "Настенная табличка из тёмного дуба",
  "block.minecraft.dark_oak_wood": "Тёмный дуб",
  "block.minecraft.dark_prismarine": "Тёмный призмарин",
  "block.minecraft.dark_prismarine_slab": "Плита из тёмного призмарина",
  "block.minecraft.dark_prismarine_stairs": "Ступеньки из тёмного призмарина",
  "block.minecraft.daylight_detector": "Датчик дневного света",
  "block.minecraft.dead_brain_coral": "Мёртвый коралл-мозговик",
  "block.minecraft.dead_brain_coral_block": "Блок мёртвого коралла-мозговика",
  "block.minecraft.dead_brain_coral_fan": "Мёртвый веерный коралл-мозговик",
  "block.minecraft.dead_brain_coral_wall_fan": "Мёртвый горизонтальный веерный коралл-мозговик",
  "block.minecraft.dead_bubble_coral": "Мёртвый пузырчатый коралл",
  "block.minecraft.dead_bubble_coral_block": "Блок мёртвого пузырчатого коралла",
  "block.minecraft.dead_bubble_coral_fan": "Мёртвый веерный пузырчатый коралл",
  "block.minecraft.dead_bubble_coral_wall_fan": "Мёртвый горизонтальный веерный пузырчатый коралл",
  "block.minecraft.dead_bush": "Мёртвый куст",
  "block.minecraft.dead_fire_coral": "Мёртвый огненный коралл",
  "block.minecraft.dead_fire_coral_block": "Блок мёртвого огненного коралла",
  "block.minecraft.dead_fire_coral_fan": "Мёртвый веерный огненный коралл",
  "block.minecraft.dead_fire_coral_wall_fan": "Мёртвый горизонтальный веерный огненный коралл",
  "block.minecraft.dead_horn_coral": "Мёртвый роговый коралл",
  "block.minecraft.dead_horn_coral_block": "Блок мёртвого рогового коралла",
  "block.minecraft.dead_horn_coral_fan": "Мёртвый веерный роговый коралл",
  "block.minecraft.dead_horn_coral_wall_fan": "Мёртвый горизонтальный веерный роговый коралл",
  "block.minecraft.dead_tube_coral": "Мёртвый трубчатый коралл",
  "block.minecraft.dead_tube_coral_block": "Блок мёртвого трубчатого коралла",
  "block.minecraft.dead_tube_coral_fan": "Мёртвый веерный трубчатый коралл",
  "block.minecraft.dead_tube_coral_wall_fan": "Мёртвый горизонтальный веерный трубчатый коралл",
  "block.minecraft.decorated_pot": "Узорчатая ваза",
  "block.minecraft.deepslate": "Глубинный сланец",
  "block.minecraft.deepslate_brick_slab": "Плита из глубинносланцевого кирпича",
  "block.minecraft.deepslate_brick_stairs": "Ступеньки из глубинносланцевого кирпича",
  "block.minecraft.deepslate_brick_wall": "Ограда из глубинносланцевого кирпича",
  "block.minecraft.deepslate_bricks": "Глубинносланцевые кирпичи",
  "block.minecraft.deepslate_coal_ore": "Угленосный глубинный сланец",
  "block.minecraft.deepslate_copper_ore": "Меденосный глубинный сланец",
  "block.minecraft.deepslate_diamond_ore": "Алмазоносный глубинный сланец",
  "block.minecraft.deepslate_emerald_ore": "Изумрудоносный глубинный сланец",
  "block.minecraft.deepslate_gold_ore": "Золотоносный глубинный сланец",
  "block.minecraft.deepslate_iron_ore": "Железоносный глубинный сланец",
  "block.minecraft.deepslate_lapis_ore": "Лазуритоносный глубинный сланец",
  "block.minecraft.deepslate_redstone_ore": "Редстоуноносный глубинный сланец",
  "block.minecraft.deepslate_tile_slab": "Плита из глубинносланцевого плитняка",
  "block.minecraft.deepslate_tile_stairs": "Ступеньки из глубинносланцевого плитняка",
  "block.minecraft.deepslate_tile_wall": "Ограда из глубинносланцевого плитняка",
  "block.minecraft.deepslate_tiles": "Глубинносланцевый плитняк",
  "block.minecraft.detector_rail": "Рельсы с датчиком",
  "block.minecraft.diamond_block": "Алмазный блок",
  "block.minecraft.diamond_ore": "Алмазная руда",
  "block.minecraft.diorite": "Диорит",
  "block.minecraft.diorite_slab": "Диоритовая плита",
  "block.minecraft.diorite_stairs": "Диоритовые ступеньки",
  "block.minecraft.diorite_wall": "Диоритовая ограда",
  "block.minecraft.dirt": "Земля",
  "block.minecraft.dirt_path": "Тропинка",
  "block.minecraft.dispenser": "Раздатчик",
  "block.minecraft.dragon_egg": "Яйцо дракона",
  "block.minecraft.dragon_head": "Голова дракона",
  "block.minecraft.dragon_wall_head": "Настенная голова дракона",
  "block.minecraft.dried_ghast": "Высохший гаст",
  "block.minecraft.dried_kelp_block": "Блок сушёной ламинарии",
  "block.minecraft.dripstone_block": "Натёчный камень",
  "block.minecraft.dropper": "Выбрасыватель",
  "block.minecraft.emerald_block": "Изумрудный блок",
  "block.minecraft.emerald_ore": "Изумрудная руда",
  "block.minecraft.enchanting_table": "Чародейский стол",
  "block.minecraft.end_gateway": "Врата Энда",
  "block.minecraft.end_portal": "Портал Энда",
  "block.minecraft.end_portal_frame": "Рамка портала Энда",
  "block.minecraft.end_rod": "Стержень Энда",
  "block.minecraft.end_stone": "Эндерняк",
  "block.minecraft.end_stone_brick_slab": "Плита из эндернякового кирпича",
  "block.minecraft.end_stone_brick_stairs": "Ступеньки из эндернякового кирпича",
  "block.minecraft.end_stone_brick_wall": "Ограда из эндернякового кирпича",
  "block.minecraft.end_stone_bricks": "Эндерняковые кирпичи",
  "block.minecraft.ender_chest": "Эндер-сундук",
  "block.minecraft.exposed_chiseled_copper": "Потемневший точёный медный блок",
  "block.minecraft.exposed_copper": "Потемневший медный блок",
  "block.minecraft.exposed_copper_bars": "Потемневшие медные прутья",
  "block.minecraft.exposed_copper_bulb": "Потемневшая медная лампа",
  "block.minecraft.exposed_copper_chain": "Потемневшая медная цепь",
  "block.minecraft.exposed_copper_chest": "Потемневший медный сундук",
  "block.minecraft.exposed_copper_door": "Потемневшая медная дверь",
  "block.minecraft.exposed_copper_golem_statue": "Потемневшая статуя медного голема",
  "block.minecraft.exposed_copper_grate": "Потемневшая медная решётка",
  "block.minecraft.exposed_copper_lantern": "Потемневший медный фонарь",
  "block.minecraft.exposed_copper_trapdoor": "Потемневший медный люк",
  "block.minecraft.exposed_cut_copper": "Потемневший резной медный блок",
  "block.minecraft.exposed_cut_copper_slab": "Потемневшая резная медная плита",
  "block.minecraft.exposed_cut_copper_stairs": "Потемневшие резные медные ступеньки",
  "block.minecraft.exposed_lightning_rod": "Потемневший громоотвод",
  "block.minecraft.farmland": "Пашня",
  "block.minecraft.fern": "Папоротник",
  "block.minecraft.fire": "Огонь",
  "block.minecraft.fire_coral": "Огненный коралл",
  "block.minecraft.fire_coral_block": "Блок огненного коралла",
  "block.minecraft.fire_coral_fan": "Веерный огненный коралл",
  "block.minecraft.fire_coral_wall_fan": "Горизонтальный веерный огненный коралл",
  "block.minecraft.firefly_bush": "Куст со светлячками",
  "block.minecraft.fletching_table": "Стол лучника",
  "block.minecraft.flower_pot": "Цветочный горшок",
  "block.minecraft.flowering_azalea": "Цветущая азалия",
  "block.minecraft.flowering_azalea_leaves": "Листья цветущей азалии",
  "block.minecraft.frogspawn": "Лягушачья икра",
  "block.minecraft.frosted_ice": "Талый лёд",
  "block.minecraft.furnace": "Печь",
  "block.minecraft.gilded_blackstone": "Золочёный чернит",
  "block.minecraft.glass": "Стекло",
  "block.minecraft.glass_pane": "Стеклянная панель",
  "block.minecraft.glow_lichen": "Светящийся лишайник",
  "block.minecraft.glowstone": "Светокамень",
  "block.minecraft.gold_block": "Золотой блок",
  "block.minecraft.gold_ore": "Золотая руда",
  "block.minecraft.golden_dandelion": "Золотой одуванчик",
  "block.minecraft.granite": "Гранит",
  "block.minecraft.granite_slab": "Гранитная плита",
  "block.minecraft.granite_stairs": "Гранитные ступеньки",
  "block.minecraft.granite_wall": "Гранитная ограда",
  "block.minecraft.grass": "Трава",
  "block.minecraft.grass_block": "Дёрн",
  "block.minecraft.gravel": "Гравий",
  "block.minecraft.gray_banner": "Серый флаг",
  "block.minecraft.gray_bed": "Серая кровать",
  "block.minecraft.gray_candle": "Серая свеча",
  "block.minecraft.gray_candle_cake": "Торт с серой свечой",
  "block.minecraft.gray_carpet": "Серый ковёр",
  "block.minecraft.gray_concrete": "Серый бетон",
  "block.minecraft.gray_concrete_powder": "Серый сухой бетон",
  "block.minecraft.gray_glazed_terracotta": "Серая глазурованная керамика",
  "block.minecraft.gray_shulker_box": "Серый шалкеровый ящик",
  "block.minecraft.gray_stained_glass": "Серое стекло",
  "block.minecraft.gray_stained_glass_pane": "Серая стеклянная панель",
  "block.minecraft.gray_terracotta": "Серая керамика",
  "block.minecraft.gray_wool": "Серая шерсть",
  "block.minecraft.green_banner": "Зелёный флаг",
  "block.minecraft.green_bed": "Зелёная кровать",
  "block.minecraft.green_candle": "Зелёная свеча",
  "block.minecraft.green_candle_cake": "Торт с зелёной свечой",
  "block.minecraft.green_carpet": "Зелёный ковёр",
  "block.minecraft.green_concrete": "Зелёный бетон",
  "block.minecraft.green_concrete_powder": "Зелёный сухой бетон",
  "block.minecraft.green_glazed_terracotta": "Зелёная глазурованная керамика",
  "block.minecraft.green_shulker_box": "Зелёный шалкеровый ящик",
  "block.minecraft.green_stained_glass": "Зелёное стекло",
  "block.minecraft.green_stained_glass_pane": "Зелёная стеклянная панель",
  "block.minecraft.green_terracotta": "Зелёная керамика",
  "block.minecraft.green_wool": "Зелёная шерсть",
  "block.minecraft.grindstone": "Точило",
  "block.minecraft.hanging_roots": "Свисающие корни",
  "block.minecraft.hay_block": "Сноп сена",
  "block.minecraft.heavy_core": "Навершие булавы",
  "block.minecraft.heavy_weighted_pressure_plate": "Большегрузная весовая пластина",
  "block.minecraft.honey_block": "Блок мёда",
  "block.minecraft.honeycomb_block": "Блок пчелиных сот",
  "block.minecraft.hopper": "Воронка",
  "block.minecraft.horn_coral": "Роговый коралл",
  "block.minecraft.horn_coral_block": "Блок рогового коралла",
  "block.minecraft.horn_coral_fan": "Веерный роговый коралл",
  "block.minecraft.horn_coral_wall_fan": "Горизонтальный веерный роговый коралл",
  "block.minecraft.ice": "Лёд",
  "block.minecraft.infested_chiseled_stone_bricks": "Заражённые резные каменные кирпичи",
  "block.minecraft.infested_cobblestone": "Заражённый булыжник",
  "block.minecraft.infested_cracked_stone_bricks": "Заражённые потрескавшиеся каменные кирпичи",
  "block.minecraft.infested_deepslate": "Заражённый глубинный сланец",
  "block.minecraft.infested_mossy_stone_bricks": "Заражённые замшелые каменные кирпичи",
  "block.minecraft.infested_stone": "Заражённый камень",
  "block.minecraft.infested_stone_bricks": "Заражённые каменные кирпичи",
  "block.minecraft.iron_bars": "Железные прутья",
  "block.minecraft.iron_block": "Железный блок",
  "block.minecraft.iron_chain": "Железная цепь",
  "block.minecraft.iron_door": "Железная дверь",
  "block.minecraft.iron_ore": "Железная руда",
  "block.minecraft.iron_trapdoor": "Железный люк",
  "block.minecraft.jack_o_lantern": "Светильник Джека",
  "block.minecraft.jigsaw": "Пазл",
  "block.minecraft.jukebox": "Проигрыватель",
  "block.minecraft.jungle_button": "Кнопка из тропического дерева",
  "block.minecraft.jungle_door": "Дверь из тропического дерева",
  "block.minecraft.jungle_fence": "Забор из тропического дерева",
  "block.minecraft.jungle_fence_gate": "Калитка из тропического дерева",
  "block.minecraft.jungle_hanging_sign": "Подвесная табличка из тропического дерева",
  "block.minecraft.jungle_leaves": "Листья тропического дерева",
  "block.minecraft.jungle_log": "Бревно тропического дерева",
  "block.minecraft.jungle_planks": "Доски из тропического дерева",
  "block.minecraft.jungle_pressure_plate": "Нажимная плита из тропического дерева",
  "block.minecraft.jungle_sapling": "Саженец тропического дерева",
  "block.minecraft.jungle_shelf": "Полка из тропического дерева",
  "block.minecraft.jungle_sign": "Табличка из тропического дерева",
  "block.minecraft.jungle_slab": "Плита из тропического дерева",
  "block.minecraft.jungle_stairs": "Ступеньки из тропического дерева",
  "block.minecraft.jungle_trapdoor": "Люк из тропического дерева",
  "block.minecraft.jungle_wall_hanging_sign": "Настенная подвесная табличка из тропического дерева",
  "block.minecraft.jungle_wall_sign": "Настенная табличка из тропического дерева",
  "block.minecraft.jungle_wood": "Тропическое дерево",
  "block.minecraft.kelp": "Ламинария",
  "block.minecraft.kelp_plant": "Стебель ламинарии",
  "block.minecraft.ladder": "Лестница",
  "block.minecraft.lantern": "Фонарь",
  "block.minecraft.lapis_block": "Лазуритовый блок",
  "block.minecraft.lapis_ore": "Лазуритовая руда",
  "block.minecraft.large_amethyst_bud": "Большой аметистовый бутон",
  "block.minecraft.large_fern": "Раскидистый папоротник",
  "block.minecraft.lava": "Лава",
  "block.minecraft.lava_cauldron": "Котёл с лавой",
  "block.minecraft.leaf_litter": "Сухие листья",
  "block.minecraft.lectern": "Кафедра",
  "block.minecraft.lever": "Рычаг",
  "block.minecraft.light": "Свет",
  "block.minecraft.light_blue_banner": "Голубой флаг",
  "block.minecraft.light_blue_bed": "Голубая кровать",
  "block.minecraft.light_blue_candle": "Голубая свеча",
  "block.minecraft.light_blue_candle_cake": "Торт с голубой свечой",
  "block.minecraft.light_blue_carpet": "Голубой ковёр",
  "block.minecraft.light_blue_concrete": "Голубой бетон",
  "block.minecraft.light_blue_concrete_powder": "Голубой сухой бетон",
  "block.minecraft.light_blue_glazed_terracotta": "Голубая глазурованная керамика",
  "block.minecraft.light_blue_shulker_box": "Голубой шалкеровый ящик",
  "block.minecraft.light_blue_stained_glass": "Голубое стекло",
  "block.minecraft.light_blue_stained_glass_pane": "Голубая стеклянная панель",
  "block.minecraft.light_blue_terracotta": "Голубая керамика",
  "block.minecraft.light_blue_wool": "Голубая шерсть",
  "block.minecraft.light_gray_banner": "Светло-серый флаг",
  "block.minecraft.light_gray_bed": "Светло-серая кровать",
  "block.minecraft.light_gray_candle": "Светло-серая свеча",
  "block.minecraft.light_gray_candle_cake": "Торт со светло-серой свечой",
  "block.minecraft.light_gray_carpet": "Светло-серый ковёр",
  "block.minecraft.light_gray_concrete": "Светло-серый бетон",
  "block.minecraft.light_gray_concrete_powder": "Светло-серый сухой бетон",
  "block.minecraft.light_gray_glazed_terracotta": "Светло-серая глазурованная керамика",
  "block.minecraft.light_gray_shulker_box": "Светло-серый шалкеровый ящик",
  "block.minecraft.light_gray_stained_glass": "Светло-серое стекло",
  "block.minecraft.light_gray_stained_glass_pane": "Светло-серая стеклянная панель",
  "block.minecraft.light_gray_terracotta": "Светло-серая керамика",
  "block.minecraft.light_gray_wool": "Светло-серая шерсть",
  "block.minecraft.light_weighted_pressure_plate": "Весовая пластина",
  "block.minecraft.lightning_rod": "Громоотвод",
  "block.minecraft.lilac": "Сирень",
  "block.minecraft.lily_of_the_valley": "Ландыш",
  "block.minecraft.lily_pad": "Кувшинка",
  "block.minecraft.lime_banner": "Лаймовый флаг",
  "block.minecraft.lime_bed": "Лаймовая кровать",
  "block.minecraft.lime_candle": "Лаймовая свеча",
  "block.minecraft.lime_candle_cake": "Торт с лаймовой свечой",
  "block.minecraft.lime_carpet": "Лаймовый ковёр",
  "block.minecraft.lime_concrete": "Лаймовый бетон",
  "block.minecraft.lime_concrete_powder": "Лаймовый сухой бетон",
  "block.minecraft.lime_glazed_terracotta": "Лаймовая глазурованная керамика",
  "block.minecraft.lime_shulker_box": "Лаймовый шалкеровый ящик",
  "block.minecraft.lime_stained_glass": "Лаймовое стекло",
  "block.minecraft.lime_stained_glass_pane": "Лаймовая стеклянная панель",
  "block.minecraft.lime_terracotta": "Лаймовая керамика",
  "block.minecraft.lime_wool": "Лаймовая шерсть",
  "block.minecraft.lodestone": "Магнетит",
  "block.minecraft.loom": "Ткацкий станок",
  "block.minecraft.magenta_banner": "Пурпурный флаг",
  "block.minecraft.magenta_bed": "Пурпурная кровать",
  "block.minecraft.magenta_candle": "Пурпурная свеча",
  "block.minecraft.magenta_candle_cake": "Торт с пурпурной свечой",
  "block.minecraft.magenta_carpet": "Пурпурный ковёр",
  "block.minecraft.magenta_concrete": "Пурпурный бетон",
  "block.minecraft.magenta_concrete_powder": "Пурпурный сухой бетон",
  "block.minecraft.magenta_glazed_terracotta": "Пурпурная глазурованная керамика",
  "block.minecraft.magenta_shulker_box": "Пурпурный шалкеровый ящик",
  "block.minecraft.magenta_stained_glass": "Пурпурное стекло",
  "block.minecraft.magenta_stained_glass_pane": "Пурпурная стеклянная панель",
  "block.minecraft.magenta_terracotta": "Пурпурная керамика",
  "block.minecraft.magenta_wool": "Пурпурная шерсть",
  "block.minecraft.magma_block": "Магма",
  "block.minecraft.mangrove_button": "Мангровая кнопка",
  "block.minecraft.mangrove_door": "Мангровая дверь",
  "block.minecraft.mangrove_fence": "Мангровый забор",
  "block.minecraft.mangrove_fence_gate": "Мангровая калитка",
  "block.minecraft.mangrove_hanging_sign": "Мангровая подвесная табличка",
  "block.minecraft.mangrove_leaves": "Мангровые листья",
  "block.minecraft.mangrove_log": "Мангровое бревно",
  "block.minecraft.mangrove_planks": "Мангровые доски",
  "block.minecraft.mangrove_pressure_plate": "Мангровая нажимная плита",
  "block.minecraft.mangrove_propagule": "Мангровый отросток",
  "block.minecraft.mangrove_roots": "Мангровые корни",
  "block.minecraft.mangrove_shelf": "Мангровая полка",
  "block.minecraft.mangrove_sign": "Мангровая табличка",
  "block.minecraft.mangrove_slab": "Мангровая плита",
  "block.minecraft.mangrove_stairs": "Мангровые ступеньки",
  "block.minecraft.mangrove_trapdoor": "Мангровый люк",
  "block.minecraft.mangrove_wall_hanging_sign": "Мангровая настенная подвесная табличка",
  "block.minecraft.mangrove_wall_sign": "Мангровая настенная табличка",
  "block.minecraft.mangrove_wood": "Мангровое дерево",
  "block.minecraft.medium_amethyst_bud": "Средний аметистовый бутон",
  "block.minecraft.melon": "Арбуз",
  "block.minecraft.melon_stem": "Стебель арбуза",
  "block.minecraft.moss_block": "Блок мха",
  "block.minecraft.moss_carpet": "Моховой ковёр",
  "block.minecraft.mossy_cobblestone": "Замшелый булыжник",
  "block.minecraft.mossy_cobblestone_slab": "Замшелая булыжная плита",
  "block.minecraft.mossy_cobblestone_stairs": "Замшелые булыжные ступеньки",
  "block.minecraft.mossy_cobblestone_wall": "Замшелая булыжная ограда",
  "block.minecraft.mossy_stone_brick_slab": "Плита из замшелого каменного кирпича",
  "block.minecraft.mossy_stone_brick_stairs": "Ступеньки из замшелого каменного кирпича",
  "block.minecraft.mossy_stone_brick_wall": "Ограда из замшелого каменного кирпича",
  "block.minecraft.mossy_stone_bricks": "Замшелые каменные кирпичи",
  "block.minecraft.moving_piston": "Движущийся поршень",
  "block.minecraft.mud": "Грязь",
  "block.minecraft.mud_brick_slab": "Саманная плита",
  "block.minecraft.mud_brick_stairs": "Саманные ступеньки",
  "block.minecraft.mud_brick_wall": "Саманная ограда",
  "block.minecraft.mud_bricks": "Саманные кирпичи",
  "block.minecraft.muddy_mangrove_roots": "Грязные мангровые корни",
  "block.minecraft.mushroom_stem": "Ножка гриба",
  "block.minecraft.mycelium": "Мицелий",
  "block.minecraft.nether_brick_fence": "Забор из незерского кирпича",
  "block.minecraft.nether_brick_slab": "Плита из незерского кирпича",
  "block.minecraft.nether_brick_stairs": "Ступеньки из незерского кирпича",
  "block.minecraft.nether_brick_wall": "Ограда из незерского кирпича",
  "block.minecraft.nether_bricks": "Незерские кирпичи",
  "block.minecraft.nether_gold_ore": "Незерская золотая руда",
  "block.minecraft.nether_portal": "Портал Незера",
  "block.minecraft.nether_quartz_ore": "Руда незерского кварца",
  "block.minecraft.nether_sprouts": "Незерские ростки",
  "block.minecraft.nether_wart": "Незерский нарост",
  "block.minecraft.nether_wart_block": "Блок незерского нароста",
  "block.minecraft.netherite_block": "Незеритовый блок",
  "block.minecraft.netherrack": "Незерак",
  "block.minecraft.note_block": "Нотный блок",
  "block.minecraft.oak_button": "Дубовая кнопка",
  "block.minecraft.oak_door": "Дубовая дверь",
  "block.minecraft.oak_fence": "Дубовый забор",
  "block.minecraft.oak_fence_gate": "Дубовая калитка",
  "block.minecraft.oak_hanging_sign": "Дубовая подвесная табличка",
  "block.minecraft.oak_leaves": "Дубовые листья",
  "block.minecraft.oak_log": "Дубовое бревно",
  "block.minecraft.oak_planks": "Дубовые доски",
  "block.minecraft.oak_pressure_plate": "Дубовая нажимная плита",
  "block.minecraft.oak_sapling": "Саженец дуба",
  "block.minecraft.oak_shelf": "Дубовая полка",
  "block.minecraft.oak_sign": "Дубовая табличка",
  "block.minecraft.oak_slab": "Дубовая плита",
  "block.minecraft.oak_stairs": "Дубовые ступеньки",
  "block.minecraft.oak_trapdoor": "Дубовый люк",
  "block.minecraft.oak_wall_hanging_sign": "Дубовая настенная подвесная табличка",
  "block.minecraft.oak_wall_sign": "Дубовая настенная табличка",
  "block.minecraft.oak_wood": "Дуб",
  "block.minecraft.observer": "Наблюдатель",
  "block.minecraft.obsidian": "Обсидиан",
  "block.minecraft.ochre_froglight": "Охристая квампа",
  "block.minecraft.ominous_banner": "Зловещий флаг",
  "block.minecraft.open_eyeblossom": "Раскрытая глазалия",
  "block.minecraft.orange_banner": "Оранжевый флаг",
  "block.minecraft.orange_bed": "Оранжевая кровать",
  "block.minecraft.orange_candle": "Оранжевая свеча",
  "block.minecraft.orange_candle_cake": "Торт с оранжевой свечой",
  "block.minecraft.orange_carpet": "Оранжевый ковёр",
  "block.minecraft.orange_concrete": "Оранжевый бетон",
  "block.minecraft.orange_concrete_powder": "Оранжевый сухой бетон",
  "block.minecraft.orange_glazed_terracotta": "Оранжевая глазурованная керамика",
  "block.minecraft.orange_shulker_box": "Оранжевый шалкеровый ящик",
  "block.minecraft.orange_stained_glass": "Оранжевое стекло",
  "block.minecraft.orange_stained_glass_pane": "Оранжевая стеклянная панель",
  "block.minecraft.orange_terracotta": "Оранжевая керамика",
  "block.minecraft.orange_tulip": "Оранжевый тюльпан",
  "block.minecraft.orange_wool": "Оранжевая шерсть",
  "block.minecraft.oxeye_daisy": "Ромашка",
  "block.minecraft.oxidized_chiseled_copper": "Окисленный точёный медный блок",
  "block.minecraft.oxidized_copper": "Окисленный медный блок",
  "block.minecraft.oxidized_copper_bars": "Окисленные медные прутья",
  "block.minecraft.oxidized_copper_bulb": "Окисленная медная лампа",
  "block.minecraft.oxidized_copper_chain": "Окисленная медная цепь",
  "block.minecraft.oxidized_copper_chest": "Окисленный медный сундук",
  "block.minecraft.oxidized_copper_door": "Окисленная медная дверь",
  "block.minecraft.oxidized_copper_golem_statue": "Окисленная статуя медного голема",
  "block.minecraft.oxidized_copper_grate": "Окисленная медная решётка",
  "block.minecraft.oxidized_copper_lantern": "Окисленный медный фонарь",
  "block.minecraft.oxidized_copper_trapdoor": "Окисленный медный люк",
  "block.minecraft.oxidized_cut_copper": "Окисленный резной медный блок",
  "block.minecraft.oxidized_cut_copper_slab": "Окисленная резная медная плита",
  "block.minecraft.oxidized_cut_copper_stairs": "Окисленные резные медные ступеньки",
  "block.minecraft.oxidized_lightning_rod": "Окисленный громоотвод",
  "block.minecraft.packed_ice": "Плотный лёд",
  "block.minecraft.packed_mud": "Плотная грязь",
  "block.minecraft.pale_hanging_moss": "Свисающий бледный мох",
  "block.minecraft.pale_moss_block": "Блок бледного мха",
  "block.minecraft.pale_moss_carpet": "Бледный моховой ковёр",
  "block.minecraft.pale_oak_button": "Кнопка из бледного дуба",
  "block.minecraft.pale_oak_door": "Дверь из бледного дуба",
  "block.minecraft.pale_oak_fence": "Забор из бледного дуба",
  "block.minecraft.pale_oak_fence_gate": "Калитка из бледного дуба",
  "block.minecraft.pale_oak_hanging_sign": "Подвесная табличка из бледного дуба",
  "block.minecraft.pale_oak_leaves": "Листья бледного дуба",
  "block.minecraft.pale_oak_log": "Бревно бледного дуба",
  "block.minecraft.pale_oak_planks": "Доски из бледного дуба",
  "block.minecraft.pale_oak_pressure_plate": "Нажимная плита из бледного дуба",
  "block.minecraft.pale_oak_sapling": "Саженец бледного дуба",
  "block.minecraft.pale_oak_shelf": "Полка из бледного дуба",
  "block.minecraft.pale_oak_sign": "Табличка из бледного дуба",
  "block.minecraft.pale_oak_slab": "Плита из бледного дуба",
  "block.minecraft.pale_oak_stairs": "Ступеньки из бледного дуба",
  "block.minecraft.pale_oak_trapdoor": "Люк из бледного дуба",
  "block.minecraft.pale_oak_wall_hanging_sign": "Настенная подвесная табличка из бледного дуба",
  "block.minecraft.pale_oak_wall_sign": "Настенная табличка из бледного дуба",
  "block.minecraft.pale_oak_wood": "Бледный дуб",
  "block.minecraft.pearlescent_froglight": "Перламутровая квампа",
  "block.minecraft.peony": "Пион",
  "block.minecraft.petrified_oak_slab": "Окаменевшая дубовая плита",
  "block.minecraft.piglin_head": "Голова пиглина",
  "block.minecraft.piglin_wall_head": "Настенная голова пиглина",
  "block.minecraft.pink_banner": "Розовый флаг",
  "block.minecraft.pink_bed": "Розовая кровать",
  "block.minecraft.pink_candle": "Розовая свеча",
  "block.minecraft.pink_candle_cake": "Торт с розовой свечой",
  "block.minecraft.pink_carpet": "Розовый ковёр",
  "block.minecraft.pink_concrete": "Розовый бетон",
  "block.minecraft.pink_concrete_powder": "Розовый сухой бетон",
  "block.minecraft.pink_glazed_terracotta": "Розовая глазурованная керамика",
  "block.minecraft.pink_petals": "Розовые лепестки",
  "block.minecraft.pink_shulker_box": "Розовый шалкеровый ящик",
  "block.minecraft.pink_stained_glass": "Розовое стекло",
  "block.minecraft.pink_stained_glass_pane": "Розовая стеклянная панель",
  "block.minecraft.pink_terracotta": "Розовая керамика",
  "block.minecraft.pink_tulip": "Розовый тюльпан",
  "block.minecraft.pink_wool": "Розовая шерсть",
  "block.minecraft.piston": "Поршень",
  "block.minecraft.piston_head": "Головка поршня",
  "block.minecraft.pitcher_crop": "Росток кувшинницы",
  "block.minecraft.pitcher_plant": "Кувшинница",
  "block.minecraft.player_head": "Голова игрока",
  "block.minecraft.player_head.named": "Голова %s",
  "block.minecraft.player_wall_head": "Настенная голова игрока",
  "block.minecraft.podzol": "Подзол",
  "block.minecraft.pointed_dripstone": "Капельник",
  "block.minecraft.polished_andesite": "Полированный андезит",
  "block.minecraft.polished_andesite_slab": "Плита из полированного андезита",
  "block.minecraft.polished_andesite_stairs": "Ступеньки из полированного андезита",
  "block.minecraft.polished_basalt": "Полированный базальт",
  "block.minecraft.polished_blackstone": "Полированный чернит",
  "block.minecraft.polished_blackstone_brick_slab": "Плита из полированно-чернитного кирпича",
  "block.minecraft.polished_blackstone_brick_stairs": "Ступеньки из полированно-чернитного кирпича",
  "block.minecraft.polished_blackstone_brick_wall": "Ограда из полированно-чернитного кирпича",
  "block.minecraft.polished_blackstone_bricks": "Полированно-чернитные кирпичи",
  "block.minecraft.polished_blackstone_button": "Кнопка из полированного чернита",
  "block.minecraft.polished_blackstone_pressure_plate": "Нажимная плита из полированного чернита",
  "block.minecraft.polished_blackstone_slab": "Плита из полированного чернита",
  "block.minecraft.polished_blackstone_stairs": "Ступеньки из полированного чернита",
  "block.minecraft.polished_blackstone_wall": "Ограда из полированного чернита",
  "block.minecraft.polished_deepslate": "Полированный глубинный сланец",
  "block.minecraft.polished_deepslate_slab": "Плита из полированного глубинного сланца",
  "block.minecraft.polished_deepslate_stairs": "Ступеньки из полированного глубинного сланца",
  "block.minecraft.polished_deepslate_wall": "Ограда из полированного глубинного сланца",
  "block.minecraft.polished_diorite": "Полированный диорит",
  "block.minecraft.polished_diorite_slab": "Плита из полированного диорита",
  "block.minecraft.polished_diorite_stairs": "Ступеньки из полированного диорита",
  "block.minecraft.polished_granite": "Полированный гранит",
  "block.minecraft.polished_granite_slab": "Плита из полированного гранита",
  "block.minecraft.polished_granite_stairs": "Ступеньки из полированного гранита",
  "block.minecraft.polished_tuff": "Полированный туф",
  "block.minecraft.polished_tuff_slab": "Плита из полированного туфа",
  "block.minecraft.polished_tuff_stairs": "Ступеньки из полированного туфа",
  "block.minecraft.polished_tuff_wall": "Ограда из полированного туфа",
  "block.minecraft.poppy": "Мак",
  "block.minecraft.potatoes": "Картофель",
  "block.minecraft.potted_acacia_sapling": "Саженец акации в горшке",
  "block.minecraft.potted_allium": "Лук-батун в горшке",
  "block.minecraft.potted_azalea_bush": "Азалия в горшке",
  "block.minecraft.potted_azure_bluet": "Хаустония серая в горшке",
  "block.minecraft.potted_bamboo": "Бамбук в горшке",
  "block.minecraft.potted_birch_sapling": "Саженец берёзы в горшке",
  "block.minecraft.potted_blue_orchid": "Синяя орхидея в горшке",
  "block.minecraft.potted_brown_mushroom": "Коричневый гриб в горшке",
  "block.minecraft.potted_cactus": "Кактус в горшке",
  "block.minecraft.potted_cherry_sapling": "Саженец вишни в горшке",
  "block.minecraft.potted_closed_eyeblossom": "Закрытая глазалия в горшке",
  "block.minecraft.potted_cornflower": "Синий василёк в горшке",
  "block.minecraft.potted_crimson_fungus": "Багровый гриб в горшке",
  "block.minecraft.potted_crimson_roots": "Багровые корни в горшке",
  "block.minecraft.potted_dandelion": "Одуванчик в горшке",
  "block.minecraft.potted_dark_oak_sapling": "Саженец тёмного дуба в горшке",
  "block.minecraft.potted_dead_bush": "Мёртвый куст в горшке",
  "block.minecraft.potted_fern": "Папоротник в горшке",
  "block.minecraft.potted_flowering_azalea_bush": "Цветущая азалия в горшке",
  "block.minecraft.potted_golden_dandelion": "Золотой одуванчик в горшке",
  "block.minecraft.potted_jungle_sapling": "Саженец тропического дерева в горшке",
  "block.minecraft.potted_lily_of_the_valley": "Ландыш в горшке",
  "block.minecraft.potted_mangrove_propagule": "Мангровый отросток в горшке",
  "block.minecraft.potted_oak_sapling": "Саженец дуба в горшке",
  "block.minecraft.potted_open_eyeblossom": "Раскрытая глазалия в горшке",
  "block.minecraft.potted_orange_tulip": "Оранжевый тюльпан в горшке",
  "block.minecraft.potted_oxeye_daisy": "Ромашка в горшке",
  "block.minecraft.potted_pale_oak_sapling": "Саженец бледного дуба в горшке",
  "block.minecraft.potted_pink_tulip": "Розовый тюльпан в горшке",
  "block.minecraft.potted_poppy": "Мак в горшке",
  "block.minecraft.potted_red_mushroom": "Красный гриб в горшке",
  "block.minecraft.potted_red_tulip": "Красный тюльпан в горшке",
  "block.minecraft.potted_spruce_sapling": "Саженец ели в горшке",
  "block.minecraft.potted_torchflower": "Факельник в горшке",
  "block.minecraft.potted_warped_fungus": "Искажённый гриб в горшке",
  "block.minecraft.potted_warped_roots": "Искажённые корни в горшке",
  "block.minecraft.potted_white_tulip": "Белый тюльпан в горшке",
  "block.minecraft.potted_wither_rose": "Роза визера в горшке",
  "block.minecraft.powder_snow": "Рыхлый снег",
  "block.minecraft.powder_snow_cauldron": "Котёл с рыхлым снегом",
  "block.minecraft.powered_rail": "Энергорельсы",
  "block.minecraft.prismarine": "Призмарин",
  "block.minecraft.prismarine_brick_slab": "Плита из призмаринового кирпича",
  "block.minecraft.prismarine_brick_stairs": "Ступеньки из призмаринового кирпича",
  "block.minecraft.prismarine_bricks": "Призмариновые кирпичи",
  "block.minecraft.prismarine_slab": "Призмариновая плита",
  "block.minecraft.prismarine_stairs": "Призмариновые ступеньки",
  "block.minecraft.prismarine_wall": "Призмариновая ограда",
  "block.minecraft.pumpkin": "Тыква",
  "block.minecraft.pumpkin_stem": "Стебель тыквы",
  "block.minecraft.purple_banner": "Фиолетовый флаг",
  "block.minecraft.purple_bed": "Фиолетовая кровать",
  "block.minecraft.purple_candle": "Фиолетовая свеча",
  "block.minecraft.purple_candle_cake": "Торт с фиолетовой свечой",
  "block.minecraft.purple_carpet": "Фиолетовый ковёр",
  "block.minecraft.purple_concrete": "Фиолетовый бетон",
  "block.minecraft.purple_concrete_powder": "Фиолетовый сухой бетон",
  "block.minecraft.purple_glazed_terracotta": "Фиолетовая глазурованная керамика",
  "block.minecraft.purple_shulker_box": "Фиолетовый шалкеровый ящик",
  "block.minecraft.purple_stained_glass": "Фиолетовое стекло",
  "block.minecraft.purple_stained_glass_pane": "Фиолетовая стеклянная панель",
  "block.minecraft.purple_terracotta": "Фиолетовая керамика",
  "block.minecraft.purple_wool": "Фиолетовая шерсть",
  "block.minecraft.purpur_block": "Пурпур",
  "block.minecraft.purpur_pillar": "Пурпуровый пилон",
  "block.minecraft.purpur_slab": "Пурпуровая плита",
  "block.minecraft.purpur_stairs": "Пурпуровые ступеньки",
  "block.minecraft.quartz_block": "Кварцевый блок",
  "block.minecraft.quartz_bricks": "Кварцевые кирпичи",
  "block.minecraft.quartz_pillar": "Кварцевая колонна",
  "block.minecraft.quartz_slab": "Кварцевая плита",
  "block.minecraft.quartz_stairs": "Кварцевые ступеньки",
  "block.minecraft.rail": "Рельсы",
  "block.minecraft.raw_copper_block": "Блок рудной меди",
  "block.minecraft.raw_gold_block": "Блок рудного золота",
  "block.minecraft.raw_iron_block": "Блок рудного железа",
  "block.minecraft.red_banner": "Красный флаг",
  "block.minecraft.red_bed": "Красная кровать",
  "block.minecraft.red_candle": "Красная свеча",
  "block.minecraft.red_candle_cake": "Торт с красной свечой",
  "block.minecraft.red_carpet": "Красный ковёр",
  "block.minecraft.red_concrete": "Красный бетон",
  "block.minecraft.red_concrete_powder": "Красный сухой бетон",
  "block.minecraft.red_glazed_terracotta": "Красная глазурованная керамика",
  "block.minecraft.red_mushroom": "Красный гриб",
  "block.minecraft.red_mushroom_block": "Блок красного гриба",
  "block.minecraft.red_nether_brick_slab": "Плита из красного незерского кирпича",
  "block.minecraft.red_nether_brick_stairs": "Ступеньки из красного незерского кирпича",
  "block.minecraft.red_nether_brick_wall": "Ограда из красного незерского кирпича",
  "block.minecraft.red_nether_bricks": "Красные незерские кирпичи",
  "block.minecraft.red_sand": "Красный песок",
  "block.minecraft.red_sandstone": "Красный песчаник",
  "block.minecraft.red_sandstone_slab": "Плита из красного песчаника",
  "block.minecraft.red_sandstone_stairs": "Ступеньки из красного песчаника",
  "block.minecraft.red_sandstone_wall": "Ограда из красного песчаника",
  "block.minecraft.red_shulker_box": "Красный шалкеровый ящик",
  "block.minecraft.red_stained_glass": "Красное стекло",
  "block.minecraft.red_stained_glass_pane": "Красная стеклянная панель",
  "block.minecraft.red_terracotta": "Красная керамика",
  "block.minecraft.red_tulip": "Красный тюльпан",
  "block.minecraft.red_wool": "Красная шерсть",
  "block.minecraft.redstone_block": "Редстоуновый блок",
  "block.minecraft.redstone_lamp": "Редстоуновая лампа",
  "block.minecraft.redstone_ore": "Редстоуновая руда",
  "block.minecraft.redstone_torch": "Редстоуновый факел",
  "block.minecraft.redstone_wall_torch": "Настенный редстоуновый факел",
  "block.minecraft.redstone_wire": "Редстоуновый провод",
  "block.minecraft.reinforced_deepslate": "Укреплённый глубинный сланец",
  "block.minecraft.repeater": "Редстоуновый повторитель",
  "block.minecraft.repeating_command_block": "Повторяющий командный блок",
  "block.minecraft.resin_block": "Смоляной блок",
  "block.minecraft.resin_brick_slab": "Плита из смоляного кирпича",
  "block.minecraft.resin_brick_stairs": "Ступеньки из смоляного кирпича",
  "block.minecraft.resin_brick_wall": "Ограда из смоляного кирпича",
  "block.minecraft.resin_bricks": "Смоляные кирпичи",
  "block.minecraft.resin_clump": "Сгусток смолы",
  "block.minecraft.respawn_anchor": "Якорь возрождения",
  "block.minecraft.rooted_dirt": "Корнистая земля",
  "block.minecraft.rose_bush": "Розовый куст",
  "block.minecraft.sand": "Песок",
  "block.minecraft.sandstone": "Песчаник",
  "block.minecraft.sandstone_slab": "Песчаниковая плита",
  "block.minecraft.sandstone_stairs": "Песчаниковые ступеньки",
  "block.minecraft.sandstone_wall": "Песчаниковая ограда",
  "block.minecraft.scaffolding": "Подмостки",
  "block.minecraft.sculk": "Скалк",
  "block.minecraft.sculk_catalyst": "Скалковый катализатор",
  "block.minecraft.sculk_sensor": "Скалк-сенсор",
  "block.minecraft.sculk_shrieker": "Скалковый крикун",
  "block.minecraft.sculk_vein": "Скалковая жила",
  "block.minecraft.sea_lantern": "Морской фонарь",
  "block.minecraft.sea_pickle": "Морской огурец",
  "block.minecraft.seagrass": "Морская трава",
  "block.minecraft.set_spawn": "Точка возрождения установлена",
  "block.minecraft.short_dry_grass": "Низкая сухая трава",
  "block.minecraft.short_grass": "Низкая трава",
  "block.minecraft.shroomlight": "Грибосвет",
  "block.minecraft.shulker_box": "Шалкеровый ящик",
  "block.minecraft.skeleton_skull": "Череп",
  "block.minecraft.skeleton_wall_skull": "Настенный череп",
  "block.minecraft.slime_block": "Блок слизи",
  "block.minecraft.small_amethyst_bud": "Малый аметистовый бутон",
  "block.minecraft.small_dripleaf": "Маленькая бросянка",
  "block.minecraft.smithing_table": "Стол кузнеца",
  "block.minecraft.smoker": "Коптильня",
  "block.minecraft.smooth_basalt": "Гладкий базальт",
  "block.minecraft.smooth_quartz": "Гладкий кварц",
  "block.minecraft.smooth_quartz_slab": "Плита из гладкого кварца",
  "block.minecraft.smooth_quartz_stairs": "Ступеньки из гладкого кварца",
  "block.minecraft.smooth_red_sandstone": "Гладкий красный песчаник",
  "block.minecraft.smooth_red_sandstone_slab": "Плита из гладкого красного песчаника",
  "block.minecraft.smooth_red_sandstone_stairs": "Ступеньки из гладкого красного песчаника",
  "block.minecraft.smooth_sandstone": "Гладкий песчаник",
  "block.minecraft.smooth_sandstone_slab": "Плита из гладкого песчаника",
  "block.minecraft.smooth_sandstone_stairs": "Ступеньки из гладкого песчаника",
  "block.minecraft.smooth_stone": "Гладкий камень",
  "block.minecraft.smooth_stone_slab": "Плита из гладкого камня",
  "block.minecraft.sniffer_egg": "Яйцо нюхача",
  "block.minecraft.snow": "Снег",
  "block.minecraft.snow_block": "Блок снега",
  "block.minecraft.soul_campfire": "Костёр душ",
  "block.minecraft.soul_fire": "Огонь душ",
  "block.minecraft.soul_lantern": "Фонарь душ",
  "block.minecraft.soul_sand": "Песок душ",
  "block.minecraft.soul_soil": "Почва душ",
  "block.minecraft.soul_torch": "Факел душ",
  "block.minecraft.soul_wall_torch": "Настенный факел душ",
  "block.minecraft.spawn.not_valid": "У вас нет кровати или заряженного якоря возрождения, либо доступ к ним затруднён",
  "block.minecraft.spawner": "Рассадник монстров",
  "block.minecraft.spawner.desc1": "Взаимодействие с яйцом призыва:",
  "block.minecraft.spawner.desc2": "определяет тип моба",
  "block.minecraft.sponge": "Губка",
  "block.minecraft.spore_blossom": "Спороцвет",
  "block.minecraft.spruce_button": "Еловая кнопка",
  "block.minecraft.spruce_door": "Еловая дверь",
  "block.minecraft.spruce_fence": "Еловый забор",
  "block.minecraft.spruce_fence_gate": "Еловая калитка",
  "block.minecraft.spruce_hanging_sign": "Еловая подвесная табличка",
  "block.minecraft.spruce_leaves": "Хвоя",
  "block.minecraft.spruce_log": "Еловое бревно",
  "block.minecraft.spruce_planks": "Еловые доски",
  "block.minecraft.spruce_pressure_plate": "Еловая нажимная плита",
  "block.minecraft.spruce_sapling": "Саженец ели",
  "block.minecraft.spruce_shelf": "Еловая полка",
  "block.minecraft.spruce_sign": "Еловая табличка",
  "block.minecraft.spruce_slab": "Еловая плита",
  "block.minecraft.spruce_stairs": "Еловые ступеньки",
  "block.minecraft.spruce_trapdoor": "Еловый люк",
  "block.minecraft.spruce_wall_hanging_sign": "Еловая настенная подвесная табличка",
  "block.minecraft.spruce_wall_sign": "Еловая настенная табличка",
  "block.minecraft.spruce_wood": "Ель",
  "block.minecraft.sticky_piston": "Липкий поршень",
  "block.minecraft.stone": "Камень",
  "block.minecraft.stone_brick_slab": "Плита из каменного кирпича",
  "block.minecraft.stone_brick_stairs": "Ступеньки из каменного кирпича",
  "block.minecraft.stone_brick_wall": "Ограда из каменного кирпича",
  "block.minecraft.stone_bricks": "Каменные кирпичи",
  "block.minecraft.stone_button": "Каменная кнопка",
  "block.minecraft.stone_pressure_plate": "Каменная нажимная плита",
  "block.minecraft.stone_slab": "Каменная плита",
  "block.minecraft.stone_stairs": "Каменные ступеньки",
  "block.minecraft.stonecutter": "Камнерез",
  "block.minecraft.stripped_acacia_log": "Обтёсанное акациевое бревно",
  "block.minecraft.stripped_acacia_wood": "Обтёсанная акациевая древесина",
  "block.minecraft.stripped_bamboo_block": "Блок обтёсанного бамбука",
  "block.minecraft.stripped_birch_log": "Обтёсанное берёзовое бревно",
  "block.minecraft.stripped_birch_wood": "Обтёсанная берёзовая древесина",
  "block.minecraft.stripped_cherry_log": "Обтёсанное вишнёвое бревно",
  "block.minecraft.stripped_cherry_wood": "Обтёсанная вишнёвая древесина",
  "block.minecraft.stripped_crimson_hyphae": "Очищенные багровые гифы",
  "block.minecraft.stripped_crimson_stem": "Очищенный багровый стебель",
  "block.minecraft.stripped_dark_oak_log": "Обтёсанное бревно тёмного дуба",
  "block.minecraft.stripped_dark_oak_wood": "Обтёсанная древесина тёмного дуба",
  "block.minecraft.stripped_jungle_log": "Обтёсанное бревно тропического дерева",
  "block.minecraft.stripped_jungle_wood": "Обтёсанная тропическая древесина",
  "block.minecraft.stripped_mangrove_log": "Обтёсанное мангровое бревно",
  "block.minecraft.stripped_mangrove_wood": "Обтёсанная мангровая древесина",
  "block.minecraft.stripped_oak_log": "Обтёсанное дубовое бревно",
  "block.minecraft.stripped_oak_wood": "Обтёсанная дубовая древесина",
  "block.minecraft.stripped_pale_oak_log": "Обтёсанное бревно бледного дуба",
  "block.minecraft.stripped_pale_oak_wood": "Обтёсанная древесина бледного дуба",
  "block.minecraft.stripped_spruce_log": "Обтёсанное еловое бревно",
  "block.minecraft.stripped_spruce_wood": "Обтёсанная еловая древесина",
  "block.minecraft.stripped_warped_hyphae": "Очищенные искажённые гифы",
  "block.minecraft.stripped_warped_stem": "Очищенный искажённый стебель",
  "block.minecraft.structure_block": "Блок-конструктор",
  "block.minecraft.structure_void": "Пустой блок",
  "block.minecraft.sugar_cane": "Сахарный тростник",
  "block.minecraft.sunflower": "Подсолнух",
  "block.minecraft.suspicious_gravel": "Подозрительный гравий",
  "block.minecraft.suspicious_sand": "Подозрительный песок",
  "block.minecraft.sweet_berry_bush": "Куст сладких ягод",
  "block.minecraft.tall_dry_grass": "Высокая сухая трава",
  "block.minecraft.tall_grass": "Высокая трава",
  "block.minecraft.tall_seagrass": "Высокая морская трава",
  "block.minecraft.target": "Мишень",
  "block.minecraft.terracotta": "Терракота",
  "block.minecraft.test_block": "Блок-тестер",
  "block.minecraft.test_instance_block": "Блок-тестер экземпляра",
  "block.minecraft.tinted_glass": "Тонированное стекло",
  "block.minecraft.tnt": "Динамит",
  "block.minecraft.tnt.disabled": "Взрывы динамита отключены",
  "block.minecraft.torch": "Факел",
  "block.minecraft.torchflower": "Факельник",
  "block.minecraft.torchflower_crop": "Росток факельника",
  "block.minecraft.trapped_chest": "Сундук-ловушка",
  "block.minecraft.trial_spawner": "Рассадник испытаний",
  "block.minecraft.tripwire": "Растяжка",
  "block.minecraft.tripwire_hook": "Крюк",
  "block.minecraft.tube_coral": "Трубчатый коралл",
  "block.minecraft.tube_coral_block": "Блок трубчатого коралла",
  "block.minecraft.tube_coral_fan": "Веерный трубчатый коралл",
  "block.minecraft.tube_coral_wall_fan": "Горизонтальный веерный трубчатый коралл",
  "block.minecraft.tuff": "Туф",
  "block.minecraft.tuff_brick_slab": "Плита из туфового кирпича",
  "block.minecraft.tuff_brick_stairs": "Ступеньки из туфового кирпича",
  "block.minecraft.tuff_brick_wall": "Ограда из туфового кирпича",
  "block.minecraft.tuff_bricks": "Туфовые кирпичи",
  "block.minecraft.tuff_slab": "Туфовая плита",
  "block.minecraft.tuff_stairs": "Туфовые ступеньки",
  "block.minecraft.tuff_wall": "Туфовая ограда",
  "block.minecraft.turtle_egg": "Черепашье яйцо",
  "block.minecraft.twisting_vines": "Вьющаяся лоза",
  "block.minecraft.twisting_vines_plant": "Стебель вьющейся лозы",
  "block.minecraft.vault": "Хранилище",
  "block.minecraft.verdant_froglight": "Малахитовая квампа",
  "block.minecraft.vine": "Лианы",
  "block.minecraft.void_air": "Вакуум",
  "block.minecraft.wall_torch": "Настенный факел",
  "block.minecraft.warped_button": "Искажённая кнопка",
  "block.minecraft.warped_door": "Искажённая дверь",
  "block.minecraft.warped_fence": "Искажённый забор",
  "block.minecraft.warped_fence_gate": "Искажённая калитка",
  "block.minecraft.warped_fungus": "Искажённый гриб",
  "block.minecraft.warped_hanging_sign": "Искажённая подвесная табличка",
  "block.minecraft.warped_hyphae": "Искажённые гифы",
  "block.minecraft.warped_nylium": "Искажённый нилий",
  "block.minecraft.warped_planks": "Искажённые доски",
  "block.minecraft.warped_pressure_plate": "Искажённая нажимная плита",
  "block.minecraft.warped_roots": "Искажённые корни",
  "block.minecraft.warped_shelf": "Искажённая полка",
  "block.minecraft.warped_sign": "Искажённая табличка",
  "block.minecraft.warped_slab": "Искажённая плита",
  "block.minecraft.warped_stairs": "Искажённые ступеньки",
  "block.minecraft.warped_stem": "Искажённый стебель",
  "block.minecraft.warped_trapdoor": "Искажённый люк",
  "block.minecraft.warped_wall_hanging_sign": "Искажённая настенная подвесная табличка",
  "block.minecraft.warped_wall_sign": "Искажённая настенная табличка",
  "block.minecraft.warped_wart_block": "Блок искажённого нароста",
  "block.minecraft.water": "Вода",
  "block.minecraft.water_cauldron": "Котёл с водой",
  "block.minecraft.waxed_chiseled_copper": "Вощёный точёный медный блок",
  "block.minecraft.waxed_copper_bars": "Вощёные медные прутья",
  "block.minecraft.waxed_copper_block": "Вощёный медный блок",
  "block.minecraft.waxed_copper_bulb": "Вощёная медная лампа",
  "block.minecraft.waxed_copper_chain": "Вощёная медная цепь",
  "block.minecraft.waxed_copper_chest": "Вощёный медный сундук",
  "block.minecraft.waxed_copper_door": "Вощёная медная дверь",
  "block.minecraft.waxed_copper_golem_statue": "Вощёная статуя медного голема",
  "block.minecraft.waxed_copper_grate": "Вощёная медная решётка",
  "block.minecraft.waxed_copper_lantern": "Вощёный медный фонарь",
  "block.minecraft.waxed_copper_trapdoor": "Вощёный медный люк",
  "block.minecraft.waxed_cut_copper": "Вощёный резной медный блок",
  "block.minecraft.waxed_cut_copper_slab": "Вощёная резная медная плита",
  "block.minecraft.waxed_cut_copper_stairs": "Вощёные резные медные ступеньки",
  "block.minecraft.waxed_exposed_chiseled_copper": "Вощёный потемневший точёный медный блок",
  "block.minecraft.waxed_exposed_copper": "Вощёный потемневший медный блок",
  "block.minecraft.waxed_exposed_copper_bars": "Вощёные потемневшие медные прутья",
  "block.minecraft.waxed_exposed_copper_bulb": "Вощёная потемневшая медная лампа",
  "block.minecraft.waxed_exposed_copper_chain": "Вощёная потемневшая медная цепь",
  "block.minecraft.waxed_exposed_copper_chest": "Вощёный потемневший медный сундук",
  "block.minecraft.waxed_exposed_copper_door": "Вощёная потемневшая медная дверь",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Вощёная потемневшая статуя медного голема",
  "block.minecraft.waxed_exposed_copper_grate": "Вощёная потемневшая медная решётка",
  "block.minecraft.waxed_exposed_copper_lantern": "Вощёный потемневший медный фонарь",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Вощёный потемневший медный люк",
  "block.minecraft.waxed_exposed_cut_copper": "Вощёный потемневший резной медный блок",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Вощёная потемневшая резная медная плита",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Вощёные потемневшие резные медные ступеньки",
  "block.minecraft.waxed_exposed_lightning_rod": "Вощёный потемневший громоотвод",
  "block.minecraft.waxed_lightning_rod": "Вощёный громоотвод",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Вощёный окисленный точёный медный блок",
  "block.minecraft.waxed_oxidized_copper": "Вощёный окисленный медный блок",
  "block.minecraft.waxed_oxidized_copper_bars": "Вощёные окисленные медные прутья",
  "block.minecraft.waxed_oxidized_copper_bulb": "Вощёная окисленная медная лампа",
  "block.minecraft.waxed_oxidized_copper_chain": "Вощёная окисленная медная цепь",
  "block.minecraft.waxed_oxidized_copper_chest": "Вощёный окисленный медный сундук",
  "block.minecraft.waxed_oxidized_copper_door": "Вощёная окисленная медная дверь",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Вощёная окисленная статуя медного голема",
  "block.minecraft.waxed_oxidized_copper_grate": "Вощёная окисленная медная решётка",
  "block.minecraft.waxed_oxidized_copper_lantern": "Вощёный окисленный медный фонарь",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Вощёный окисленный медный люк",
  "block.minecraft.waxed_oxidized_cut_copper": "Вощёный окисленный резной медный блок",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Вощёная окисленная резная медная плита",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Вощёные окисленные резные медные ступеньки",
  "block.minecraft.waxed_oxidized_lightning_rod": "Вощёный окисленный громоотвод",
  "block.minecraft.waxed_weathered_chiseled_copper": "Вощёный состаренный точёный медный блок",
  "block.minecraft.waxed_weathered_copper": "Вощёный состаренный медный блок",
  "block.minecraft.waxed_weathered_copper_bars": "Вощёные состаренные медные прутья",
  "block.minecraft.waxed_weathered_copper_bulb": "Вощёная состаренная медная лампа",
  "block.minecraft.waxed_weathered_copper_chain": "Вощёная состаренная медная цепь",
  "block.minecraft.waxed_weathered_copper_chest": "Вощёный состаренный медный сундук",
  "block.minecraft.waxed_weathered_copper_door": "Вощёная состаренная медная дверь",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Вощёная состаренная статуя медного голема",
  "block.minecraft.waxed_weathered_copper_grate": "Вощёная состаренная медная решётка",
  "block.minecraft.waxed_weathered_copper_lantern": "Вощёный состаренный медный фонарь",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Вощёный состаренный медный люк",
  "block.minecraft.waxed_weathered_cut_copper": "Вощёный состаренный резной медный блок",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Вощёная состаренная резная медная плита",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Вощёные состаренные резные медные ступеньки",
  "block.minecraft.waxed_weathered_lightning_rod": "Вощёный состаренный громоотвод",
  "block.minecraft.weathered_chiseled_copper": "Состаренный точёный медный блок",
  "block.minecraft.weathered_copper": "Состаренный медный блок",
  "block.minecraft.weathered_copper_bars": "Состаренные медные прутья",
  "block.minecraft.weathered_copper_bulb": "Состаренная медная лампа",
  "block.minecraft.weathered_copper_chain": "Состаренная медная цепь",
  "block.minecraft.weathered_copper_chest": "Состаренный медный сундук",
  "block.minecraft.weathered_copper_door": "Состаренная медная дверь",
  "block.minecraft.weathered_copper_golem_statue": "Состаренная статуя медного голема",
  "block.minecraft.weathered_copper_grate": "Состаренная медная решётка",
  "block.minecraft.weathered_copper_lantern": "Состаренный медный фонарь",
  "block.minecraft.weathered_copper_trapdoor": "Состаренный медный люк",
  "block.minecraft.weathered_cut_copper": "Состаренный резной медный блок",
  "block.minecraft.weathered_cut_copper_slab": "Состаренная резная медная плита",
  "block.minecraft.weathered_cut_copper_stairs": "Состаренные резные медные ступеньки",
  "block.minecraft.weathered_lightning_rod": "Состаренный громоотвод",
  "block.minecraft.weeping_vines": "Плакучая лоза",
  "block.minecraft.weeping_vines_plant": "Стебель плакучей лозы",
  "block.minecraft.wet_sponge": "Мокрая губка",
  "block.minecraft.wheat": "Ростки пшеницы",
  "block.minecraft.white_banner": "Белый флаг",
  "block.minecraft.white_bed": "Белая кровать",
  "block.minecraft.white_candle": "Белая свеча",
  "block.minecraft.white_candle_cake": "Торт с белой свечой",
  "block.minecraft.white_carpet": "Белый ковёр",
  "block.minecraft.white_concrete": "Белый бетон",
  "block.minecraft.white_concrete_powder": "Белый сухой бетон",
  "block.minecraft.white_glazed_terracotta": "Белая глазурованная керамика",
  "block.minecraft.white_shulker_box": "Белый шалкеровый ящик",
  "block.minecraft.white_stained_glass": "Белое стекло",
  "block.minecraft.white_stained_glass_pane": "Белая стеклянная панель",
  "block.minecraft.white_terracotta": "Белая керамика",
  "block.minecraft.white_tulip": "Белый тюльпан",
  "block.minecraft.white_wool": "Белая шерсть",
  "block.minecraft.wildflowers": "Полевые цветы",
  "block.minecraft.wither_rose": "Роза визера",
  "block.minecraft.wither_skeleton_skull": "Череп визер-скелета",
  "block.minecraft.wither_skeleton_wall_skull": "Настенный череп визер-скелета",
  "block.minecraft.yellow_banner": "Жёлтый флаг",
  "block.minecraft.yellow_bed": "Жёлтая кровать",
  "block.minecraft.yellow_candle": "Жёлтая свеча",
  "block.minecraft.yellow_candle_cake": "Торт с жёлтой свечой",
  "block.minecraft.yellow_carpet": "Жёлтый ковёр",
  "block.minecraft.yellow_concrete": "Жёлтый бетон",
  "block.minecraft.yellow_concrete_powder": "Жёлтый сухой бетон",
  "block.minecraft.yellow_glazed_terracotta": "Жёлтая глазурованная керамика",
  "block.minecraft.yellow_shulker_box": "Жёлтый шалкеровый ящик",
  "block.minecraft.yellow_stained_glass": "Жёлтое стекло",
  "block.minecraft.yellow_stained_glass_pane": "Жёлтая стеклянная панель",
  "block.minecraft.yellow_terracotta": "Жёлтая керамика",
  "block.minecraft.yellow_wool": "Жёлтая шерсть",
  "block.minecraft.zombie_head": "Голова зомби",
  "block.minecraft.zombie_wall_head": "Настенная голова зомби",
  "item.minecraft.acacia_boat": "Акациевая лодка",
  "item.minecraft.acacia_chest_boat": "Акациевая грузовая лодка",
  "item.minecraft.allay_spawn_egg": "Яйцо призыва тихони",
  "item.minecraft.amethyst_shard": "Осколок аметиста",
  "item.minecraft.angler_pottery_shard": "Глиняный черепок «Рыбак»",
  "item.minecraft.angler_pottery_sherd": "Глиняный черепок «Рыбак»",
  "item.minecraft.apple": "Яблоко",
  "item.minecraft.archer_pottery_shard": "Глиняный черепок «Лучник»",
  "item.minecraft.archer_pottery_sherd": "Глиняный черепок «Лучник»",
  "item.minecraft.armadillo_scute": "Щиток броненосца",
  "item.minecraft.armadillo_spawn_egg": "Яйцо призыва броненосца",
  "item.minecraft.armor_stand": "Стойка для брони",
  "item.minecraft.arms_up_pottery_shard": "Глиняный черепок «Руки вверх»",
  "item.minecraft.arms_up_pottery_sherd": "Глиняный черепок «Руки вверх»",
  "item.minecraft.arrow": "Стрела",
  "item.minecraft.axolotl_bucket": "Аксолотль в ведре",
  "item.minecraft.axolotl_spawn_egg": "Яйцо призыва аксолотля",
  "item.minecraft.baked_potato": "Печёный картофель",
  "item.minecraft.bamboo_chest_raft": "Грузовой бамбуковый плот",
  "item.minecraft.bamboo_raft": "Бамбуковый плот",
  "item.minecraft.bat_spawn_egg": "Яйцо призыва летучей мыши",
  "item.minecraft.bee_spawn_egg": "Яйцо призыва пчелы",
  "item.minecraft.beef": "Сырая говядина",
  "item.minecraft.beetroot": "Свёкла",
  "item.minecraft.beetroot_seeds": "Семена свёклы",
  "item.minecraft.beetroot_soup": "Свекольный суп",
  "item.minecraft.birch_boat": "Берёзовая лодка",
  "item.minecraft.birch_chest_boat": "Берёзовая грузовая лодка",
  "item.minecraft.black_bundle": "Чёрный мешок",
  "item.minecraft.black_dye": "Чёрный краситель",
  "item.minecraft.black_harness": "Чёрная упряжь",
  "item.minecraft.blade_pottery_shard": "Глиняный черепок «Клинок»",
  "item.minecraft.blade_pottery_sherd": "Глиняный черепок «Клинок»",
  "item.minecraft.blaze_powder": "Огненный порошок",
  "item.minecraft.blaze_rod": "Огненный стержень",
  "item.minecraft.blaze_spawn_egg": "Яйцо призыва всполоха",
  "item.minecraft.blue_bundle": "Синий мешок",
  "item.minecraft.blue_dye": "Синий краситель",
  "item.minecraft.blue_egg": "Голубое яйцо",
  "item.minecraft.blue_harness": "Синяя упряжь",
  "item.minecraft.bogged_spawn_egg": "Яйцо призыва болотника",
  "item.minecraft.bolt_armor_trim_smithing_template": "Кузнечный шаблон",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Отделка «Ось»",
  "item.minecraft.bone": "Кость",
  "item.minecraft.bone_meal": "Костная мука",
  "item.minecraft.book": "Книга",
  "item.minecraft.bordure_indented_banner_pattern": "Узор флага «Зубчатая кайма»",
  "item.minecraft.bow": "Лук",
  "item.minecraft.bowl": "Миска",
  "item.minecraft.bread": "Хлеб",
  "item.minecraft.breeze_rod": "Вихревой стержень",
  "item.minecraft.breeze_spawn_egg": "Яйцо призыва вихря",
  "item.minecraft.brewer_pottery_shard": "Глиняный черепок «Зельевар»",
  "item.minecraft.brewer_pottery_sherd": "Глиняный черепок «Зельевар»",
  "item.minecraft.brewing_stand": "Зельеварка",
  "item.minecraft.brick": "Кирпич",
  "item.minecraft.brown_bundle": "Коричневый мешок",
  "item.minecraft.brown_dye": "Коричневый краситель",
  "item.minecraft.brown_egg": "Коричневое яйцо",
  "item.minecraft.brown_harness": "Коричневая упряжь",
  "item.minecraft.brush": "Кисть",
  "item.minecraft.bucket": "Ведро",
  "item.minecraft.bundle": "Мешок",
  "item.minecraft.bundle.empty": "Пустой",
  "item.minecraft.bundle.empty.description": "Вмещает стопку разных предметов",
  "item.minecraft.bundle.full": "Полный",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Глиняный черепок «Пламя»",
  "item.minecraft.burn_pottery_sherd": "Глиняный черепок «Пламя»",
  "item.minecraft.camel_husk_spawn_egg": "Яйцо призыва верблюда-кадавра",
  "item.minecraft.camel_spawn_egg": "Яйцо призыва верблюда",
  "item.minecraft.carrot": "Морковь",
  "item.minecraft.carrot_on_a_stick": "Удочка с морковкой",
  "item.minecraft.cat_spawn_egg": "Яйцо призыва кошки",
  "item.minecraft.cauldron": "Котёл",
  "item.minecraft.cave_spider_spawn_egg": "Яйцо призыва пещерного паука",
  "item.minecraft.chainmail_boots": "Кольчужные ботинки",
  "item.minecraft.chainmail_chestplate": "Кольчуга",
  "item.minecraft.chainmail_helmet": "Койф",
  "item.minecraft.chainmail_leggings": "Кольчужные поножи",
  "item.minecraft.charcoal": "Древесный уголь",
  "item.minecraft.cherry_boat": "Вишнёвая лодка",
  "item.minecraft.cherry_chest_boat": "Вишнёвая грузовая лодка",
  "item.minecraft.chest_minecart": "Грузовая вагонетка",
  "item.minecraft.chicken": "Сырая курица",
  "item.minecraft.chicken_spawn_egg": "Яйцо призыва курицы",
  "item.minecraft.chorus_fruit": "Плод хоруса",
  "item.minecraft.clay_ball": "Комок глины",
  "item.minecraft.clock": "Часы",
  "item.minecraft.coal": "Уголь",
  "item.minecraft.coast_armor_trim_smithing_template": "Кузнечный шаблон",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Отделка «Берег»",
  "item.minecraft.cocoa_beans": "Какао-бобы",
  "item.minecraft.cod": "Сырая треска",
  "item.minecraft.cod_bucket": "Треска в ведре",
  "item.minecraft.cod_spawn_egg": "Яйцо призыва трески",
  "item.minecraft.command_block_minecart": "Вагонетка с командным блоком",
  "item.minecraft.compass": "Компас",
  "item.minecraft.cooked_beef": "Стейк",
  "item.minecraft.cooked_chicken": "Жареная курица",
  "item.minecraft.cooked_cod": "Жареная треска",
  "item.minecraft.cooked_mutton": "Жареная баранина",
  "item.minecraft.cooked_porkchop": "Жареная свинина",
  "item.minecraft.cooked_rabbit": "Жареная крольчатина",
  "item.minecraft.cooked_salmon": "Жареный лосось",
  "item.minecraft.cookie": "Печенье",
  "item.minecraft.copper_axe": "Медный топор",
  "item.minecraft.copper_boots": "Медные ботинки",
  "item.minecraft.copper_chestplate": "Медный нагрудник",
  "item.minecraft.copper_golem_spawn_egg": "Яйцо призыва медного голема",
  "item.minecraft.copper_helmet": "Медный шлем",
  "item.minecraft.copper_hoe": "Медная мотыга",
  "item.minecraft.copper_horse_armor": "Медная конская броня",
  "item.minecraft.copper_ingot": "Медный слиток",
  "item.minecraft.copper_leggings": "Медные поножи",
  "item.minecraft.copper_nautilus_armor": "Медная броня наутилуса",
  "item.minecraft.copper_nugget": "Кусочек меди",
  "item.minecraft.copper_pickaxe": "Медная кирка",
  "item.minecraft.copper_shovel": "Медная лопата",
  "item.minecraft.copper_spear": "Медное копьё",
  "item.minecraft.copper_sword": "Медный меч",
  "item.minecraft.cow_spawn_egg": "Яйцо призыва коровы",
  "item.minecraft.creaking_spawn_egg": "Яйцо призыва скрипуна",
  "item.minecraft.creeper_banner_pattern": "Узор флага",
  "item.minecraft.creeper_banner_pattern.desc": "Крипер",
  "item.minecraft.creeper_banner_pattern.new": "Узор флага «Крипер»",
  "item.minecraft.creeper_spawn_egg": "Яйцо призыва крипера",
  "item.minecraft.crossbow": "Арбалет",
  "item.minecraft.crossbow.projectile": "Снаряд:",
  "item.minecraft.crossbow.projectile.multiple": "Снаряд: %s × %s",
  "item.minecraft.crossbow.projectile.single": "Снаряд: %s",
  "item.minecraft.cyan_bundle": "Бирюзовый мешок",
  "item.minecraft.cyan_dye": "Бирюзовый краситель",
  "item.minecraft.cyan_harness": "Бирюзовая упряжь",
  "item.minecraft.danger_pottery_shard": "Глиняный черепок «Угроза»",
  "item.minecraft.danger_pottery_sherd": "Глиняный черепок «Угроза»",
  "item.minecraft.dark_oak_boat": "Лодка из тёмного дуба",
  "item.minecraft.dark_oak_chest_boat": "Грузовая лодка из тёмного дуба",
  "item.minecraft.debug_stick": "Палочка отладки",
  "item.minecraft.debug_stick.empty": "Свойства объекта %s не заданы",
  "item.minecraft.debug_stick.select": "выбрано «%s» (%s)",
  "item.minecraft.debug_stick.update": "«%s»: %s",
  "item.minecraft.diamond": "Алмаз",
  "item.minecraft.diamond_axe": "Алмазный топор",
  "item.minecraft.diamond_boots": "Алмазные ботинки",
  "item.minecraft.diamond_chestplate": "Алмазный нагрудник",
  "item.minecraft.diamond_helmet": "Алмазный шлем",
  "item.minecraft.diamond_hoe": "Алмазная мотыга",
  "item.minecraft.diamond_horse_armor": "Алмазная конская броня",
  "item.minecraft.diamond_leggings": "Алмазные поножи",
  "item.minecraft.diamond_nautilus_armor": "Алмазная броня наутилуса",
  "item.minecraft.diamond_pickaxe": "Алмазная кирка",
  "item.minecraft.diamond_shovel": "Алмазная лопата",
  "item.minecraft.diamond_spear": "Алмазное копьё",
  "item.minecraft.diamond_sword": "Алмазный меч",
  "item.minecraft.disc_fragment_5": "Осколок пластинки",
  "item.minecraft.disc_fragment_5.desc": "Пластинка — 5",
  "item.minecraft.dolphin_spawn_egg": "Яйцо призыва дельфина",
  "item.minecraft.donkey_spawn_egg": "Яйцо призыва осла",
  "item.minecraft.dragon_breath": "Дыхание дракона",
  "item.minecraft.dried_kelp": "Сушёная ламинария",
  "item.minecraft.drowned_spawn_egg": "Яйцо призыва утопленника",
  "item.minecraft.dune_armor_trim_smithing_template": "Кузнечный шаблон",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Отделка «Дюна»",
  "item.minecraft.echo_shard": "Осколок эха",
  "item.minecraft.egg": "Яйцо",
  "item.minecraft.elder_guardian_spawn_egg": "Яйцо призыва древнего стража",
  "item.minecraft.elytra": "Элитры",
  "item.minecraft.emerald": "Изумруд",
  "item.minecraft.enchanted_book": "Чародейская книга",
  "item.minecraft.enchanted_golden_apple": "Зачарованное золотое яблоко",
  "item.minecraft.end_crystal": "Кристалл Энда",
  "item.minecraft.ender_dragon_spawn_egg": "Яйцо призыва Эндер-дракона",
  "item.minecraft.ender_eye": "Око Эндера",
  "item.minecraft.ender_pearl": "Эндер-жемчуг",
  "item.minecraft.enderman_spawn_egg": "Яйцо призыва эндермена",
  "item.minecraft.endermite_spawn_egg": "Яйцо призыва эндермита",
  "item.minecraft.evoker_spawn_egg": "Яйцо призыва заклинателя",
  "item.minecraft.experience_bottle": "Пузырёк опыта",
  "item.minecraft.explorer_pottery_shard": "Глиняный черепок «Исследователь»",
  "item.minecraft.explorer_pottery_sherd": "Глиняный черепок «Исследователь»",
  "item.minecraft.eye_armor_trim_smithing_template": "Кузнечный шаблон",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Отделка «Око»",
  "item.minecraft.feather": "Перо",
  "item.minecraft.fermented_spider_eye": "Маринованный паучий глаз",
  "item.minecraft.field_masoned_banner_pattern": "Узор флага «Муровка»",
  "item.minecraft.filled_map": "Карта",
  "item.minecraft.fire_charge": "Огненный заряд",
  "item.minecraft.firework_rocket": "Фейерверк",
  "item.minecraft.firework_rocket.flight": "Длительность полёта:",
  "item.minecraft.firework_rocket.multiple_stars": "%s × %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Пиротехническая звезда",
  "item.minecraft.firework_star.black": "Чёрный",
  "item.minecraft.firework_star.blue": "Синий",
  "item.minecraft.firework_star.brown": "Коричневый",
  "item.minecraft.firework_star.custom_color": "Пользовательский",
  "item.minecraft.firework_star.cyan": "Бирюзовый",
  "item.minecraft.firework_star.fade_to": "Затухание в",
  "item.minecraft.firework_star.flicker": "Мерцание",
  "item.minecraft.firework_star.gray": "Серый",
  "item.minecraft.firework_star.green": "Зелёный",
  "item.minecraft.firework_star.light_blue": "Голубой",
  "item.minecraft.firework_star.light_gray": "Светло-серый",
  "item.minecraft.firework_star.lime": "Лаймовый",
  "item.minecraft.firework_star.magenta": "Пурпурный",
  "item.minecraft.firework_star.orange": "Оранжевый",
  "item.minecraft.firework_star.pink": "Розовый",
  "item.minecraft.firework_star.purple": "Фиолетовый",
  "item.minecraft.firework_star.red": "Красный",
  "item.minecraft.firework_star.shape": "Неизвестная форма",
  "item.minecraft.firework_star.shape.burst": "Всплеск",
  "item.minecraft.firework_star.shape.creeper": "Криперообразный",
  "item.minecraft.firework_star.shape.large_ball": "Большой шар",
  "item.minecraft.firework_star.shape.small_ball": "Малый шар",
  "item.minecraft.firework_star.shape.star": "Звездообразный",
  "item.minecraft.firework_star.trail": "След",
  "item.minecraft.firework_star.white": "Белый",
  "item.minecraft.firework_star.yellow": "Жёлтый",
  "item.minecraft.fishing_rod": "Удочка",
  "item.minecraft.flint": "Кремень",
  "item.minecraft.flint_and_steel": "Огниво",
  "item.minecraft.flow_armor_trim_smithing_template": "Кузнечный шаблон",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Отделка «Поток»",
  "item.minecraft.flow_banner_pattern": "Узор флага",
  "item.minecraft.flow_banner_pattern.desc": "Поток",
  "item.minecraft.flow_banner_pattern.new": "Узор флага «Поток»",
  "item.minecraft.flow_pottery_sherd": "Глиняный черепок «Поток»",
  "item.minecraft.flower_banner_pattern": "Узор флага",
  "item.minecraft.flower_banner_pattern.desc": "Цветок",
  "item.minecraft.flower_banner_pattern.new": "Узор флага «Цветок»",
  "item.minecraft.flower_pot": "Цветочный горшок",
  "item.minecraft.fox_spawn_egg": "Яйцо призыва лисицы",
  "item.minecraft.friend_pottery_shard": "Глиняный черепок «Друг»",
  "item.minecraft.friend_pottery_sherd": "Глиняный черепок «Друг»",
  "item.minecraft.frog_spawn_egg": "Яйцо призыва лягушки",
  "item.minecraft.furnace_minecart": "Самоходная вагонетка",
  "item.minecraft.ghast_spawn_egg": "Яйцо призыва гаста",
  "item.minecraft.ghast_tear": "Слеза гаста",
  "item.minecraft.glass_bottle": "Бутылочка",
  "item.minecraft.glistering_melon_slice": "Сверкающий ломтик арбуза",
  "item.minecraft.globe_banner_pattern": "Узор флага",
  "item.minecraft.globe_banner_pattern.desc": "Глобус",
  "item.minecraft.globe_banner_pattern.new": "Узор флага «Глобус»",
  "item.minecraft.glow_berries": "Светящиеся ягоды",
  "item.minecraft.glow_ink_sac": "Светящийся чернильный мешок",
  "item.minecraft.glow_item_frame": "Светящаяся рамка",
  "item.minecraft.glow_squid_spawn_egg": "Яйцо призыва светящегося спрута",
  "item.minecraft.glowstone_dust": "Светокаменная пыль",
  "item.minecraft.goat_horn": "Козий рог",
  "item.minecraft.goat_spawn_egg": "Яйцо призыва козы",
  "item.minecraft.gold_ingot": "Золотой слиток",
  "item.minecraft.gold_nugget": "Кусочек золота",
  "item.minecraft.golden_apple": "Золотое яблоко",
  "item.minecraft.golden_axe": "Золотой топор",
  "item.minecraft.golden_boots": "Золотые ботинки",
  "item.minecraft.golden_carrot": "Золотая морковь",
  "item.minecraft.golden_chestplate": "Золотой нагрудник",
  "item.minecraft.golden_helmet": "Золотой шлем",
  "item.minecraft.golden_hoe": "Золотая мотыга",
  "item.minecraft.golden_horse_armor": "Золотая конская броня",
  "item.minecraft.golden_leggings": "Золотые поножи",
  "item.minecraft.golden_nautilus_armor": "Золотая броня наутилуса",
  "item.minecraft.golden_pickaxe": "Золотая кирка",
  "item.minecraft.golden_shovel": "Золотая лопата",
  "item.minecraft.golden_spear": "Золотое копьё",
  "item.minecraft.golden_sword": "Золотой меч",
  "item.minecraft.gray_bundle": "Серый мешок",
  "item.minecraft.gray_dye": "Серый краситель",
  "item.minecraft.gray_harness": "Серая упряжь",
  "item.minecraft.green_bundle": "Зелёный мешок",
  "item.minecraft.green_dye": "Зелёный краситель",
  "item.minecraft.green_harness": "Зелёная упряжь",
  "item.minecraft.guardian_spawn_egg": "Яйцо призыва стража",
  "item.minecraft.gunpowder": "Порох",
  "item.minecraft.guster_banner_pattern": "Узор флага",
  "item.minecraft.guster_banner_pattern.desc": "Вихрь",
  "item.minecraft.guster_banner_pattern.new": "Узор флага «Вихрь»",
  "item.minecraft.guster_pottery_sherd": "Глиняный черепок «Вихрь»",
  "item.minecraft.happy_ghast_spawn_egg": "Яйцо призыва счастливого гаста",
  "item.minecraft.harness": "Упряжь",
  "item.minecraft.heart_of_the_sea": "Сердце моря",
  "item.minecraft.heart_pottery_shard": "Глиняный черепок «Сердце»",
  "item.minecraft.heart_pottery_sherd": "Глиняный черепок «Сердце»",
  "item.minecraft.heartbreak_pottery_shard": "Глиняный черепок «Разбитое сердце»",
  "item.minecraft.heartbreak_pottery_sherd": "Глиняный черепок «Разбитое сердце»",
  "item.minecraft.hoglin_spawn_egg": "Яйцо призыва хоглина",
  "item.minecraft.honey_bottle": "Бутылочка мёда",
  "item.minecraft.honeycomb": "Пчелиные соты",
  "item.minecraft.hopper_minecart": "Загрузочная вагонетка",
  "item.minecraft.horse_spawn_egg": "Яйцо призыва лошади",
  "item.minecraft.host_armor_trim_smithing_template": "Кузнечный шаблон",
  "item.minecraft.host_armor_trim_smithing_template.new": "Отделка «Вождь»",
  "item.minecraft.howl_pottery_shard": "Глиняный черепок «Вой»",
  "item.minecraft.howl_pottery_sherd": "Глиняный черепок «Вой»",
  "item.minecraft.husk_spawn_egg": "Яйцо призыва кадавра",
  "item.minecraft.ink_sac": "Чернильный мешок",
  "item.minecraft.iron_axe": "Железный топор",
  "item.minecraft.iron_boots": "Железные ботинки",
  "item.minecraft.iron_chestplate": "Железный нагрудник",
  "item.minecraft.iron_golem_spawn_egg": "Яйцо призыва железного голема",
  "item.minecraft.iron_helmet": "Железный шлем",
  "item.minecraft.iron_hoe": "Железная мотыга",
  "item.minecraft.iron_horse_armor": "Железная конская броня",
  "item.minecraft.iron_ingot": "Железный слиток",
  "item.minecraft.iron_leggings": "Железные поножи",
  "item.minecraft.iron_nautilus_armor": "Железная броня наутилуса",
  "item.minecraft.iron_nugget": "Кусочек железа",
  "item.minecraft.iron_pickaxe": "Железная кирка",
  "item.minecraft.iron_shovel": "Железная лопата",
  "item.minecraft.iron_spear": "Железное копьё",
  "item.minecraft.iron_sword": "Железный меч",
  "item.minecraft.item_frame": "Рамка",
  "item.minecraft.jungle_boat": "Лодка из тропического дерева",
  "item.minecraft.jungle_chest_boat": "Грузовая лодка из тропического дерева",
  "item.minecraft.knowledge_book": "Книга знаний",
  "item.minecraft.lapis_lazuli": "Лазурит",
  "item.minecraft.lava_bucket": "Ведро лавы",
  "item.minecraft.lead": "Поводок",
  "item.minecraft.leather": "Кожа",
  "item.minecraft.leather_boots": "Кожаные ботинки",
  "item.minecraft.leather_chestplate": "Кожаная куртка",
  "item.minecraft.leather_helmet": "Кожаный шлем",
  "item.minecraft.leather_horse_armor": "Кожаная конская броня",
  "item.minecraft.leather_leggings": "Кожаные штаны",
  "item.minecraft.light_blue_bundle": "Голубой мешок",
  "item.minecraft.light_blue_dye": "Голубой краситель",
  "item.minecraft.light_blue_harness": "Голубая упряжь",
  "item.minecraft.light_gray_bundle": "Светло-серый мешок",
  "item.minecraft.light_gray_dye": "Светло-серый краситель",
  "item.minecraft.light_gray_harness": "Светло-серая упряжь",
  "item.minecraft.lime_bundle": "Лаймовый мешок",
  "item.minecraft.lime_dye": "Лаймовый краситель",
  "item.minecraft.lime_harness": "Лаймовая упряжь",
  "item.minecraft.lingering_potion": "Туманное зелье",
  "item.minecraft.lingering_potion.effect.awkward": "Мутное туманное зелье",
  "item.minecraft.lingering_potion.effect.empty": "Несоздаваемое туманное зелье",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Туманное зелье огнестойкости",
  "item.minecraft.lingering_potion.effect.harming": "Туманное зелье вреда",
  "item.minecraft.lingering_potion.effect.healing": "Туманное зелье исцеления",
  "item.minecraft.lingering_potion.effect.infested": "Туманное зелье заражения",
  "item.minecraft.lingering_potion.effect.invisibility": "Туманное зелье невидимости",
  "item.minecraft.lingering_potion.effect.leaping": "Туманное зелье прыгучести",
  "item.minecraft.lingering_potion.effect.levitation": "Туманное зелье левитации",
  "item.minecraft.lingering_potion.effect.luck": "Туманное зелье везения",
  "item.minecraft.lingering_potion.effect.mundane": "Заурядное туманное зелье",
  "item.minecraft.lingering_potion.effect.night_vision": "Туманное зелье ночного зрения",
  "item.minecraft.lingering_potion.effect.oozing": "Туманное зелье слизистости",
  "item.minecraft.lingering_potion.effect.poison": "Туманное зелье отравления",
  "item.minecraft.lingering_potion.effect.regeneration": "Туманное зелье регенерации",
  "item.minecraft.lingering_potion.effect.slow_falling": "Туманное зелье плавного падения",
  "item.minecraft.lingering_potion.effect.slowness": "Туманное зелье замедления",
  "item.minecraft.lingering_potion.effect.strength": "Туманное зелье силы",
  "item.minecraft.lingering_potion.effect.swiftness": "Туманное зелье стремительности",
  "item.minecraft.lingering_potion.effect.thick": "Густое туманное зелье",
  "item.minecraft.lingering_potion.effect.turtle_master": "Туманное зелье черепашьей мощи",
  "item.minecraft.lingering_potion.effect.water": "Бутылочка с водяной взвесью",
  "item.minecraft.lingering_potion.effect.water_breathing": "Туманное зелье водного дыхания",
  "item.minecraft.lingering_potion.effect.weakness": "Туманное зелье слабости",
  "item.minecraft.lingering_potion.effect.weaving": "Туманное зелье плетения",
  "item.minecraft.lingering_potion.effect.wind_charged": "Туманное зелье ветрового заряда",
  "item.minecraft.llama_spawn_egg": "Яйцо призыва ламы",
  "item.minecraft.lodestone_compass": "Намагниченный компас",
  "item.minecraft.mace": "Булава",
  "item.minecraft.magenta_bundle": "Пурпурный мешок",
  "item.minecraft.magenta_dye": "Пурпурный краситель",
  "item.minecraft.magenta_harness": "Пурпурная упряжь",
  "item.minecraft.magma_cream": "Сгусток магмы",
  "item.minecraft.magma_cube_spawn_egg": "Яйцо призыва магмового куба",
  "item.minecraft.mangrove_boat": "Мангровая лодка",
  "item.minecraft.mangrove_chest_boat": "Мангровая грузовая лодка",
  "item.minecraft.map": "Чистая карта",
  "item.minecraft.melon_seeds": "Семена арбуза",
  "item.minecraft.melon_slice": "Ломтик арбуза",
  "item.minecraft.milk_bucket": "Ведро молока",
  "item.minecraft.minecart": "Вагонетка",
  "item.minecraft.miner_pottery_shard": "Глиняный черепок «Шахтёр»",
  "item.minecraft.miner_pottery_sherd": "Глиняный черепок «Шахтёр»",
  "item.minecraft.mojang_banner_pattern": "Узор флага",
  "item.minecraft.mojang_banner_pattern.desc": "Нечто",
  "item.minecraft.mojang_banner_pattern.new": "Узор флага «Нечто»",
  "item.minecraft.mooshroom_spawn_egg": "Яйцо призыва муушрума",
  "item.minecraft.mourner_pottery_shard": "Глиняный черепок «Скорбь»",
  "item.minecraft.mourner_pottery_sherd": "Глиняный черепок «Скорбь»",
  "item.minecraft.mule_spawn_egg": "Яйцо призыва мула",
  "item.minecraft.mushroom_stew": "Тушёные грибы",
  "item.minecraft.music_disc_11": "Пластинка",
  "item.minecraft.music_disc_11.desc": "C418 — 11",
  "item.minecraft.music_disc_13": "Пластинка",
  "item.minecraft.music_disc_13.desc": "C418 — 13",
  "item.minecraft.music_disc_5": "Пластинка",
  "item.minecraft.music_disc_5.desc": "Самуель Оберг — 5",
  "item.minecraft.music_disc_blocks": "Пластинка",
  "item.minecraft.music_disc_blocks.desc": "C418 — blocks",
  "item.minecraft.music_disc_cat": "Пластинка",
  "item.minecraft.music_disc_cat.desc": "C418 — cat",
  "item.minecraft.music_disc_chirp": "Пластинка",
  "item.minecraft.music_disc_chirp.desc": "C418 — chirp",
  "item.minecraft.music_disc_creator": "Пластинка",
  "item.minecraft.music_disc_creator.desc": "Лена Рейн — Creator",
  "item.minecraft.music_disc_creator_music_box": "Пластинка",
  "item.minecraft.music_disc_creator_music_box.desc": "Лена Рейн — Creator (Музыкальная шкатулка)",
  "item.minecraft.music_disc_far": "Пластинка",
  "item.minecraft.music_disc_far.desc": "C418 — far",
  "item.minecraft.music_disc_lava_chicken": "Пластинка",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions — Lava Chicken",
  "item.minecraft.music_disc_mall": "Пластинка",
  "item.minecraft.music_disc_mall.desc": "C418 — mall",
  "item.minecraft.music_disc_mellohi": "Пластинка",
  "item.minecraft.music_disc_mellohi.desc": "C418 — mellohi",
  "item.minecraft.music_disc_otherside": "Пластинка",
  "item.minecraft.music_disc_otherside.desc": "Лена Рейн — otherside",
  "item.minecraft.music_disc_pigstep": "Пластинка",
  "item.minecraft.music_disc_pigstep.desc": "Лена Рейн — Pigstep",
  "item.minecraft.music_disc_precipice": "Пластинка",
  "item.minecraft.music_disc_precipice.desc": "Аарон Шероф — Precipice",
  "item.minecraft.music_disc_relic": "Пластинка",
  "item.minecraft.music_disc_relic.desc": "Аарон Шероф — Relic",
  "item.minecraft.music_disc_stal": "Пластинка",
  "item.minecraft.music_disc_stal.desc": "C418 — stal",
  "item.minecraft.music_disc_strad": "Пластинка",
  "item.minecraft.music_disc_strad.desc": "C418 — strad",
  "item.minecraft.music_disc_tears": "Пластинка",
  "item.minecraft.music_disc_tears.desc": "Эймос Родди — Tears",
  "item.minecraft.music_disc_wait": "Пластинка",
  "item.minecraft.music_disc_wait.desc": "C418 — wait",
  "item.minecraft.music_disc_ward": "Пластинка",
  "item.minecraft.music_disc_ward.desc": "C418 — ward",
  "item.minecraft.mutton": "Сырая баранина",
  "item.minecraft.name_tag": "Бирка",
  "item.minecraft.nautilus_shell": "Раковина наутилуса",
  "item.minecraft.nautilus_spawn_egg": "Яйцо призыва наутилуса",
  "item.minecraft.nether_brick": "Незерский кирпич",
  "item.minecraft.nether_star": "Звезда Незера",
  "item.minecraft.nether_wart": "Незерский нарост",
  "item.minecraft.netherite_axe": "Незеритовый топор",
  "item.minecraft.netherite_boots": "Незеритовые ботинки",
  "item.minecraft.netherite_chestplate": "Незеритовый нагрудник",
  "item.minecraft.netherite_helmet": "Незеритовый шлем",
  "item.minecraft.netherite_hoe": "Незеритовая мотыга",
  "item.minecraft.netherite_horse_armor": "Незеритовая конская броня",
  "item.minecraft.netherite_ingot": "Незеритовый слиток",
  "item.minecraft.netherite_leggings": "Незеритовые поножи",
  "item.minecraft.netherite_nautilus_armor": "Незеритовая броня наутилуса",
  "item.minecraft.netherite_pickaxe": "Незеритовая кирка",
  "item.minecraft.netherite_scrap": "Незеритовый лом",
  "item.minecraft.netherite_shovel": "Незеритовая лопата",
  "item.minecraft.netherite_spear": "Незеритовое копьё",
  "item.minecraft.netherite_sword": "Незеритовый меч",
  "item.minecraft.netherite_upgrade_smithing_template": "Кузнечный шаблон",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Незеритовое улучшение",
  "item.minecraft.oak_boat": "Дубовая лодка",
  "item.minecraft.oak_chest_boat": "Дубовая грузовая лодка",
  "item.minecraft.ocelot_spawn_egg": "Яйцо призыва оцелота",
  "item.minecraft.ominous_bottle": "Зловещая бутылочка",
  "item.minecraft.ominous_trial_key": "Зловещий ключ испытаний",
  "item.minecraft.orange_bundle": "Оранжевый мешок",
  "item.minecraft.orange_dye": "Оранжевый краситель",
  "item.minecraft.orange_harness": "Оранжевая упряжь",
  "item.minecraft.painting": "Картина",
  "item.minecraft.pale_oak_boat": "Лодка из бледного дуба",
  "item.minecraft.pale_oak_chest_boat": "Грузовая лодка из бледного дуба",
  "item.minecraft.panda_spawn_egg": "Яйцо призыва панды",
  "item.minecraft.paper": "Бумага",
  "item.minecraft.parched_spawn_egg": "Яйцо призыва пустынника",
  "item.minecraft.parrot_spawn_egg": "Яйцо призыва попугая",
  "item.minecraft.phantom_membrane": "Мембрана фантома",
  "item.minecraft.phantom_spawn_egg": "Яйцо призыва фантома",
  "item.minecraft.pig_spawn_egg": "Яйцо призыва свиньи",
  "item.minecraft.piglin_banner_pattern": "Узор флага",
  "item.minecraft.piglin_banner_pattern.desc": "Рыло",
  "item.minecraft.piglin_banner_pattern.new": "Узор флага «Рыло»",
  "item.minecraft.piglin_brute_spawn_egg": "Яйцо призыва брутального пиглина",
  "item.minecraft.piglin_spawn_egg": "Яйцо призыва пиглина",
  "item.minecraft.pillager_spawn_egg": "Яйцо призыва разбойника",
  "item.minecraft.pink_bundle": "Розовый мешок",
  "item.minecraft.pink_dye": "Розовый краситель",
  "item.minecraft.pink_harness": "Розовая упряжь",
  "item.minecraft.pitcher_plant": "Кувшинница",
  "item.minecraft.pitcher_pod": "Стручок кувшинницы",
  "item.minecraft.plenty_pottery_shard": "Глиняный черепок «Изобилие»",
  "item.minecraft.plenty_pottery_sherd": "Глиняный черепок «Изобилие»",
  "item.minecraft.poisonous_potato": "Ядовитый картофель",
  "item.minecraft.polar_bear_spawn_egg": "Яйцо призыва белого медведя",
  "item.minecraft.popped_chorus_fruit": "Прожаренный плод хоруса",
  "item.minecraft.porkchop": "Сырая свинина",
  "item.minecraft.potato": "Картофель",
  "item.minecraft.potion": "Зелье",
  "item.minecraft.potion.effect.awkward": "Мутное зелье",
  "item.minecraft.potion.effect.empty": "Несоздаваемое зелье",
  "item.minecraft.potion.effect.fire_resistance": "Зелье огнестойкости",
  "item.minecraft.potion.effect.harming": "Зелье вреда",
  "item.minecraft.potion.effect.healing": "Зелье исцеления",
  "item.minecraft.potion.effect.infested": "Зелье заражения",
  "item.minecraft.potion.effect.invisibility": "Зелье невидимости",
  "item.minecraft.potion.effect.leaping": "Зелье прыгучести",
  "item.minecraft.potion.effect.levitation": "Зелье левитации",
  "item.minecraft.potion.effect.luck": "Зелье везения",
  "item.minecraft.potion.effect.mundane": "Заурядное зелье",
  "item.minecraft.potion.effect.night_vision": "Зелье ночного зрения",
  "item.minecraft.potion.effect.oozing": "Зелье слизистости",
  "item.minecraft.potion.effect.poison": "Зелье отравления",
  "item.minecraft.potion.effect.regeneration": "Зелье регенерации",
  "item.minecraft.potion.effect.slow_falling": "Зелье плавного падения",
  "item.minecraft.potion.effect.slowness": "Зелье замедления",
  "item.minecraft.potion.effect.strength": "Зелье силы",
  "item.minecraft.potion.effect.swiftness": "Зелье стремительности",
  "item.minecraft.potion.effect.thick": "Густое зелье",
  "item.minecraft.potion.effect.turtle_master": "Зелье черепашьей мощи",
  "item.minecraft.potion.effect.water": "Бутылочка воды",
  "item.minecraft.potion.effect.water_breathing": "Зелье водного дыхания",
  "item.minecraft.potion.effect.weakness": "Зелье слабости",
  "item.minecraft.potion.effect.weaving": "Зелье плетения",
  "item.minecraft.potion.effect.wind_charged": "Зелье ветрового заряда",
  "item.minecraft.pottery_shard_archer": "Глиняный черепок «Лучник»",
  "item.minecraft.pottery_shard_arms_up": "Глиняный черепок «Руки вверх»",
  "item.minecraft.pottery_shard_prize": "Глиняный черепок «Награда»",
  "item.minecraft.pottery_shard_skull": "Глиняный черепок «Череп»",
  "item.minecraft.powder_snow_bucket": "Ведро с рыхлым снегом",
  "item.minecraft.prismarine_crystals": "Кристалл призмарина",
  "item.minecraft.prismarine_shard": "Осколок призмарина",
  "item.minecraft.prize_pottery_shard": "Глиняный черепок «Награда»",
  "item.minecraft.prize_pottery_sherd": "Глиняный черепок «Награда»",
  "item.minecraft.pufferfish": "Иглобрюх",
  "item.minecraft.pufferfish_bucket": "Иглобрюх в ведре",
  "item.minecraft.pufferfish_spawn_egg": "Яйцо призыва иглобрюха",
  "item.minecraft.pumpkin_pie": "Тыквенный пирог",
  "item.minecraft.pumpkin_seeds": "Семена тыквы",
  "item.minecraft.purple_bundle": "Фиолетовый мешок",
  "item.minecraft.purple_dye": "Фиолетовый краситель",
  "item.minecraft.purple_harness": "Фиолетовая упряжь",
  "item.minecraft.quartz": "Незерский кварц",
  "item.minecraft.rabbit": "Сырая крольчатина",
  "item.minecraft.rabbit_foot": "Кроличья лапка",
  "item.minecraft.rabbit_hide": "Кроличья шкурка",
  "item.minecraft.rabbit_spawn_egg": "Яйцо призыва кролика",
  "item.minecraft.rabbit_stew": "Тушёный кролик",
  "item.minecraft.raiser_armor_trim_smithing_template": "Кузнечный шаблон",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Отделка «Собиратель»",
  "item.minecraft.ravager_spawn_egg": "Яйцо призыва разорителя",
  "item.minecraft.raw_copper": "Рудная медь",
  "item.minecraft.raw_gold": "Рудное золото",
  "item.minecraft.raw_iron": "Рудное железо",
  "item.minecraft.recovery_compass": "Возвратный компас",
  "item.minecraft.red_bundle": "Красный мешок",
  "item.minecraft.red_dye": "Красный краситель",
  "item.minecraft.red_harness": "Красная упряжь",
  "item.minecraft.redstone": "Редстоуновая пыль",
  "item.minecraft.resin_brick": "Смоляной кирпич",
  "item.minecraft.resin_clump": "Сгусток смолы",
  "item.minecraft.rib_armor_trim_smithing_template": "Кузнечный шаблон",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Отделка «Ребро»",
  "item.minecraft.rotten_flesh": "Гнилая плоть",
  "item.minecraft.saddle": "Седло",
  "item.minecraft.salmon": "Сырой лосось",
  "item.minecraft.salmon_bucket": "Лосось в ведре",
  "item.minecraft.salmon_spawn_egg": "Яйцо призыва лосося",
  "item.minecraft.scrape_pottery_sherd": "Глиняный черепок «Обтёсывание»",
  "item.minecraft.scute": "Щиток",
  "item.minecraft.sentry_armor_trim_smithing_template": "Кузнечный шаблон",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Отделка «Страж»",
  "item.minecraft.shaper_armor_trim_smithing_template": "Кузнечный шаблон",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Отделка «Скульптор»",
  "item.minecraft.sheaf_pottery_shard": "Глиняный черепок «Сноп»",
  "item.minecraft.sheaf_pottery_sherd": "Глиняный черепок «Сноп»",
  "item.minecraft.shears": "Ножницы",
  "item.minecraft.sheep_spawn_egg": "Яйцо призыва овцы",
  "item.minecraft.shelter_pottery_shard": "Глиняный черепок «Укрытие»",
  "item.minecraft.shelter_pottery_sherd": "Глиняный черепок «Укрытие»",
  "item.minecraft.shield": "Щит",
  "item.minecraft.shield.black": "Чёрный щит",
  "item.minecraft.shield.blue": "Синий щит",
  "item.minecraft.shield.brown": "Коричневый щит",
  "item.minecraft.shield.cyan": "Бирюзовый щит",
  "item.minecraft.shield.gray": "Серый щит",
  "item.minecraft.shield.green": "Зелёный щит",
  "item.minecraft.shield.light_blue": "Голубой щит",
  "item.minecraft.shield.light_gray": "Светло-серый щит",
  "item.minecraft.shield.lime": "Лаймовый щит",
  "item.minecraft.shield.magenta": "Пурпурный щит",
  "item.minecraft.shield.orange": "Оранжевый щит",
  "item.minecraft.shield.pink": "Розовый щит",
  "item.minecraft.shield.purple": "Фиолетовый щит",
  "item.minecraft.shield.red": "Красный щит",
  "item.minecraft.shield.white": "Белый щит",
  "item.minecraft.shield.yellow": "Жёлтый щит",
  "item.minecraft.shulker_shell": "Панцирь шалкера",
  "item.minecraft.shulker_spawn_egg": "Яйцо призыва шалкера",
  "item.minecraft.sign": "Табличка",
  "item.minecraft.silence_armor_trim_smithing_template": "Кузнечный шаблон",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Отделка «Тишина»",
  "item.minecraft.silverfish_spawn_egg": "Яйцо призыва чешуйницы",
  "item.minecraft.skeleton_horse_spawn_egg": "Яйцо призыва лошади-скелета",
  "item.minecraft.skeleton_spawn_egg": "Яйцо призыва скелета",
  "item.minecraft.skull_banner_pattern": "Узор флага",
  "item.minecraft.skull_banner_pattern.desc": "Череп",
  "item.minecraft.skull_banner_pattern.new": "Узор флага «Череп»",
  "item.minecraft.skull_pottery_shard": "Глиняный черепок «Череп»",
  "item.minecraft.skull_pottery_sherd": "Глиняный черепок «Череп»",
  "item.minecraft.slime_ball": "Сгусток слизи",
  "item.minecraft.slime_spawn_egg": "Яйцо призыва слизня",
  "item.minecraft.smithing_template": "Кузнечный шаблон",
  "item.minecraft.smithing_template.applies_to": "Применяется к:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Поместите слиток или кристалл",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Доспехам",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Поместите элемент брони",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Слитки и кристаллы",
  "item.minecraft.smithing_template.ingredients": "Материалы:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Поместите незеритовый слиток",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Алмазному снаряжению",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Поместите алмазный доспех, инструмент или оружие",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Незеритовый слиток",
  "item.minecraft.smithing_template.upgrade": "Улучшение: ",
  "item.minecraft.sniffer_spawn_egg": "Яйцо призыва нюхача",
  "item.minecraft.snort_pottery_shard": "Глиняный черепок «Шмыг»",
  "item.minecraft.snort_pottery_sherd": "Глиняный черепок «Шмыг»",
  "item.minecraft.snout_armor_trim_smithing_template": "Кузнечный шаблон",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Отделка «Рыло»",
  "item.minecraft.snow_golem_spawn_egg": "Яйцо призыва снежного голема",
  "item.minecraft.snowball": "Снежок",
  "item.minecraft.spectral_arrow": "Спектральная стрела",
  "item.minecraft.spider_eye": "Паучий глаз",
  "item.minecraft.spider_spawn_egg": "Яйцо призыва паука",
  "item.minecraft.spire_armor_trim_smithing_template": "Кузнечный шаблон",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Отделка «Шпиль»",
  "item.minecraft.splash_potion": "Взрывное зелье",
  "item.minecraft.splash_potion.effect.awkward": "Мутное взрывное зелье",
  "item.minecraft.splash_potion.effect.empty": "Несоздаваемое взрывное зелье",
  "item.minecraft.splash_potion.effect.fire_resistance": "Взрывное зелье огнестойкости",
  "item.minecraft.splash_potion.effect.harming": "Взрывное зелье вреда",
  "item.minecraft.splash_potion.effect.healing": "Взрывное зелье исцеления",
  "item.minecraft.splash_potion.effect.infested": "Взрывное зелье заражения",
  "item.minecraft.splash_potion.effect.invisibility": "Взрывное зелье невидимости",
  "item.minecraft.splash_potion.effect.leaping": "Взрывное зелье прыгучести",
  "item.minecraft.splash_potion.effect.levitation": "Взрывное зелье левитации",
  "item.minecraft.splash_potion.effect.luck": "Взрывное зелье везения",
  "item.minecraft.splash_potion.effect.mundane": "Заурядное взрывное зелье",
  "item.minecraft.splash_potion.effect.night_vision": "Взрывное зелье ночного зрения",
  "item.minecraft.splash_potion.effect.oozing": "Взрывное зелье слизистости",
  "item.minecraft.splash_potion.effect.poison": "Взрывное зелье отравления",
  "item.minecraft.splash_potion.effect.regeneration": "Взрывное зелье регенерации",
  "item.minecraft.splash_potion.effect.slow_falling": "Взрывное зелье плавного падения",
  "item.minecraft.splash_potion.effect.slowness": "Взрывное зелье замедления",
  "item.minecraft.splash_potion.effect.strength": "Взрывное зелье силы",
  "item.minecraft.splash_potion.effect.swiftness": "Взрывное зелье стремительности",
  "item.minecraft.splash_potion.effect.thick": "Густое взрывное зелье",
  "item.minecraft.splash_potion.effect.turtle_master": "Взрывное зелье черепашьей мощи",
  "item.minecraft.splash_potion.effect.water": "Взрывная бутылочка воды",
  "item.minecraft.splash_potion.effect.water_breathing": "Взрывное зелье водного дыхания",
  "item.minecraft.splash_potion.effect.weakness": "Взрывное зелье слабости",
  "item.minecraft.splash_potion.effect.weaving": "Взрывное зелье плетения",
  "item.minecraft.splash_potion.effect.wind_charged": "Взрывное зелье ветрового заряда",
  "item.minecraft.spruce_boat": "Еловая лодка",
  "item.minecraft.spruce_chest_boat": "Еловая грузовая лодка",
  "item.minecraft.spyglass": "Подзорная труба",
  "item.minecraft.squid_spawn_egg": "Яйцо призыва спрута",
  "item.minecraft.stick": "Палка",
  "item.minecraft.stone_axe": "Каменный топор",
  "item.minecraft.stone_hoe": "Каменная мотыга",
  "item.minecraft.stone_pickaxe": "Каменная кирка",
  "item.minecraft.stone_shovel": "Каменная лопата",
  "item.minecraft.stone_spear": "Каменное копьё",
  "item.minecraft.stone_sword": "Каменный меч",
  "item.minecraft.stray_spawn_egg": "Яйцо призыва зимогора",
  "item.minecraft.strider_spawn_egg": "Яйцо призыва лавомерки",
  "item.minecraft.string": "Нить",
  "item.minecraft.sugar": "Сахар",
  "item.minecraft.suspicious_stew": "Загадочное рагу",
  "item.minecraft.sweet_berries": "Сладкие ягоды",
  "item.minecraft.tadpole_bucket": "Головастик в ведре",
  "item.minecraft.tadpole_spawn_egg": "Яйцо призыва головастика",
  "item.minecraft.tide_armor_trim_smithing_template": "Кузнечный шаблон",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Отделка «Прилив»",
  "item.minecraft.tipped_arrow": "Обработанная стрела",
  "item.minecraft.tipped_arrow.effect.awkward": "Обработанная стрела",
  "item.minecraft.tipped_arrow.effect.empty": "Обработанная несоздаваемым зельем стрела",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Стрела огнестойкости",
  "item.minecraft.tipped_arrow.effect.harming": "Стрела вреда",
  "item.minecraft.tipped_arrow.effect.healing": "Стрела исцеления",
  "item.minecraft.tipped_arrow.effect.infested": "Стрела заражения",
  "item.minecraft.tipped_arrow.effect.invisibility": "Стрела невидимости",
  "item.minecraft.tipped_arrow.effect.leaping": "Стрела прыгучести",
  "item.minecraft.tipped_arrow.effect.levitation": "Стрела левитации",
  "item.minecraft.tipped_arrow.effect.luck": "Стрела везения",
  "item.minecraft.tipped_arrow.effect.mundane": "Обработанная стрела",
  "item.minecraft.tipped_arrow.effect.night_vision": "Стрела ночного зрения",
  "item.minecraft.tipped_arrow.effect.oozing": "Стрела слизистости",
  "item.minecraft.tipped_arrow.effect.poison": "Стрела отравления",
  "item.minecraft.tipped_arrow.effect.regeneration": "Стрела регенерации",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Стрела плавного падения",
  "item.minecraft.tipped_arrow.effect.slowness": "Стрела замедления",
  "item.minecraft.tipped_arrow.effect.strength": "Стрела силы",
  "item.minecraft.tipped_arrow.effect.swiftness": "Стрела стремительности",
  "item.minecraft.tipped_arrow.effect.thick": "Обработанная стрела",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Стрела черепашьей мощи",
  "item.minecraft.tipped_arrow.effect.water": "Взрывная стрела",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Стрела водного дыхания",
  "item.minecraft.tipped_arrow.effect.weakness": "Стрела слабости",
  "item.minecraft.tipped_arrow.effect.weaving": "Стрела плетения",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Стрела ветрового заряда",
  "item.minecraft.tnt_minecart": "Вагонетка с динамитом",
  "item.minecraft.torchflower_seeds": "Семена факельника",
  "item.minecraft.totem_of_undying": "Тотем бессмертия",
  "item.minecraft.trader_llama_spawn_egg": "Яйцо призыва ламы торговца",
  "item.minecraft.trial_key": "Ключ испытаний",
  "item.minecraft.trident": "Трезубец",
  "item.minecraft.tropical_fish": "Тропическая рыба",
  "item.minecraft.tropical_fish_bucket": "Тропическая рыба в ведре",
  "item.minecraft.tropical_fish_spawn_egg": "Яйцо призыва тропической рыбы",
  "item.minecraft.turtle_helmet": "Черепаший панцирь",
  "item.minecraft.turtle_scute": "Черепаший щиток",
  "item.minecraft.turtle_spawn_egg": "Яйцо призыва черепахи",
  "item.minecraft.vex_armor_trim_smithing_template": "Кузнечный шаблон",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Отделка «Вредина»",
  "item.minecraft.vex_spawn_egg": "Яйцо призыва вредины",
  "item.minecraft.villager_spawn_egg": "Яйцо призыва крестьянина",
  "item.minecraft.vindicator_spawn_egg": "Яйцо призыва поборника",
  "item.minecraft.wandering_trader_spawn_egg": "Яйцо призыва странствующего торговца",
  "item.minecraft.ward_armor_trim_smithing_template": "Кузнечный шаблон",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Отделка «Хранитель»",
  "item.minecraft.warden_spawn_egg": "Яйцо призыва хранителя",
  "item.minecraft.warped_fungus_on_a_stick": "Удочка с искажённым грибом",
  "item.minecraft.water_bucket": "Ведро воды",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Кузнечный шаблон",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Отделка «Искатель»",
  "item.minecraft.wheat": "Пшеница",
  "item.minecraft.wheat_seeds": "Семена пшеницы",
  "item.minecraft.white_bundle": "Белый мешок",
  "item.minecraft.white_dye": "Белый краситель",
  "item.minecraft.white_harness": "Белая упряжь",
  "item.minecraft.wild_armor_trim_smithing_template": "Кузнечный шаблон",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Отделка «Дебри»",
  "item.minecraft.wind_charge": "Заряд ветра",
  "item.minecraft.witch_spawn_egg": "Яйцо призыва ведьмы",
  "item.minecraft.wither_skeleton_spawn_egg": "Яйцо призыва визер-скелета",
  "item.minecraft.wither_spawn_egg": "Яйцо призыва визера",
  "item.minecraft.wolf_armor": "Волчья броня",
  "item.minecraft.wolf_spawn_egg": "Яйцо призыва волка",
  "item.minecraft.wooden_axe": "Деревянный топор",
  "item.minecraft.wooden_hoe": "Деревянная мотыга",
  "item.minecraft.wooden_pickaxe": "Деревянная кирка",
  "item.minecraft.wooden_shovel": "Деревянная лопата",
  "item.minecraft.wooden_spear": "Деревянное копьё",
  "item.minecraft.wooden_sword": "Деревянный меч",
  "item.minecraft.writable_book": "Книга и перо",
  "item.minecraft.written_book": "Завершённая книга",
  "item.minecraft.yellow_bundle": "Жёлтый мешок",
  "item.minecraft.yellow_dye": "Жёлтый краситель",
  "item.minecraft.yellow_harness": "Жёлтая упряжь",
  "item.minecraft.zoglin_spawn_egg": "Яйцо призыва зоглина",
  "item.minecraft.zombie_horse_spawn_egg": "Яйцо призыва лошади-зомби",
  "item.minecraft.zombie_nautilus_spawn_egg": "Яйцо призыва наутилуса-зомби",
  "item.minecraft.zombie_spawn_egg": "Яйцо призыва зомби",
  "item.minecraft.zombie_villager_spawn_egg": "Яйцо призыва крестьянина-зомби",
  "item.minecraft.zombified_piglin_spawn_egg": "Яйцо призыва зомбифицированного пиглина"
}
export const ru_ru = items; 
